import { ConversionType, CycleCheckerEnum, DateEnum, EmployeeRolesEnum, ErrorResponse, GlobalStatus, GlobalVariableValues, LogOperationsEnum, SaleOrderStatusEnum, SoStatusEnum, StatusEnum, stockDropdownData, StockStatus, stockTypeEnum, TransactionType } from '@gtpl/shared-models/common-models';
import { ItemCategoriesDropDownResponseModel, ItemCategoryDropDownDto, ItemSubCategoriesDropDownResponse, ItemSubCategoryDropDownDto, GetItemForProductRequest, ItemCategoryReq, ItemRequest, ItemSubCategoryRequest, SizeRequest, ItemsDropDownResponseModel, ItemsDropDownDto, CommonResponse, BrandsRequest, SizesDropDownResponseModel, SizesDropDownDto, TrimsMappingRequset, RMrackStatusRequest, BrandReqForLocation, RmRackPositionIdReq, RmOccupancyEnum } from '@gtpl/shared-models/masters';

import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService, MasterBrandService, TrimsMappingService, RmRackPositionService } from '@gtpl/shared-services/masters';

import { AllStockResponseModel, AvailableStockQtyResponseModel, AvailStockDto, CycleCheckerDto, GetAvailableStockResponse, InventoryLogsDto, ItemIdReq, LocationUpdateRequest, PackingSTItems, ProductConversionModel, ReClassificationReq, StockDto, StockQtyResponseModel, StockResponseDto, StoreConsumptionStatus, StoreIssuesRequestDto, TransferItemsDetails } from '@gtpl/shared-models/procurement-management';


import { BomUpdateRequest, SaleOrderDropDownDto, SaleOrderFewDetailsDto, SaleOrderDropDownResponseModel, DummyPackBomItemsRequest, ItemsDetailsResponseModel, ProductBarcodeRequest, SoRequest } from '@gtpl/shared-models/sale-management';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable, Query } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { min } from 'class-validator';
import { groupBy } from 'rxjs/operators';
import { getManager, MoreThan, Not, Repository, ReturningStatementNotSupportedError } from 'typeorm';
import { StockRepository } from '../grn/repository/stock-repository';
import { CategorySubCategoryReq } from './dto/category- sub-category-id.reqest';
import { ItemCategoryIdReq } from './dto/item-category-id.request';
import { QtyRequest } from './dto/qty-request';
import { ItemRemovedQty } from './dto/remove-stock-qty.dto';
import { SaleOrderIdRequest } from './dto/sale-order-id.request';
import { StockInputRequest } from './dto/stock-input.request';
import { StockItemRequest } from './dto/stock-item.request';
import { StockAdapter } from './dto/stock.adapter';
import { UnitRequest } from './dto/unit.id.request';
import { Stock } from './stock.entity';
import { SizeIdRequest } from './dto/size-request';
import appSettings from 'apps/services/config';
import { ItemIDRequest } from './dto/stock-for-itemid-.request';
import { PlantRoleRequest } from './dto/plant-role-req';
import { ProductConversion } from './product-conversion-entity';
import { PlantItemSubCategoryIdReq } from './dto/plant-itemsubcategory-request';
import { PackingBomRequest } from './packing-bom.request';
import { CycleChecker } from './cycle-checker.entity';
import { CycleCheckerAdapter } from './dto/cycle-checker.adapter';
import { CycleCheckerDTO } from './dto/cycle-checker.dto';
import { CycleCheckerRepository } from './repository/cycle-checker-repository';
import { AssignedStockLog } from './assigned-stock-log.entity';
import { CycleCheckerDateRequest, ItemIdRequest } from './dto/cycle-checker.request';
import { MaterialPreperationRequest } from './dto/material-preperation.req';
import { PreapredStock } from './prepared-stock.entity';
import { MaterialPreperationAdapter } from './dto/materail-preperation-adapter';
import { MaterialPreperationRepository } from './repository/material-preperation-repository';
import { PreparedStockRequest } from './dto/prepared-stock-req';
import { ItemCodeRequest } from './dto/item-code.request.dto';
import { StockIdReq } from './dto/stock-id-req';
import { BarcodeReq } from './dto/barcode-req';
import { MaterialGridRequest } from './dto/material-preparation.request';
import { GRNLocationMappingRequest } from './dto/location-mapping-req';
import { SOBomRequest } from './dto/so-bom-request';
import { GrnItemsInfo } from '../grn/dto/grn-items-info.model';
import { GrnItems } from '../grn/grn-items.entity';
import { PoItems } from '../po-creation/po-creation-items.entity';
import { PoItemsRepository } from '../po-creation/repository/po-items.repository';
import { PoRepository } from '../po-creation/repository/po-repository';
import { StockLog } from './stock-log.entity';
import { invoiceNumberRequest } from '../grn/dto/invoice-number-req';
import { UnitIdRequest } from '../store-consumption/dto/unit-id.request';
import { StoreConsumptionService } from '@gtpl/shared-services/procurement';
import { LocationRequest } from './dto/location-id.request';
import { StoreConsumption } from '../store-consumption/entity/store-consumption.entity';
import { StoreConsumptionRepository } from '../store-consumption/repository/store-consumption.repository';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { TransferItemsRepository } from '../transfer-material/repositories/transfer-items.repository';
import { BomRepository } from 'apps/services/sale-service/src/app/saleorder/repository/bom-calculation.repository';
import { LocationWiseStockLogRepository } from '../transfer-material/repositories/location-wise-stock-log.repository';
import { LocationWiseTranfers } from '../transfer-material/entities/location-wise-transfers.entity';
import { ProductConversionReq } from './dto/product-conversion.req';
import { ProductConversionAdapter } from './dto/product-conversion-adapter';
import { InvntoryLogs } from './inventory-logs';
import { InvetoryLogdDto } from './dto/inventory-logs-dto';



const salesSoTable = appSettings.sales_db + '.sale_order';

@Injectable()
export class StockService {
    constructor(
        private logService: LogsService,

        private stockRepository: StockRepository,
        private materialPreperationRepo: MaterialPreperationRepository,
        private stockAdapter: StockAdapter,
        @InjectRepository(ProductConversion)
        private productConversionRepository: Repository<ProductConversion>,
        private itemCategoryService: ItemCategoryService,
        private itemService: ItemsService,
        private sizeService: SizesService,
        private saleService: SaleOrderService,
        private trimsmappingService: TrimsMappingService,
        private subCategoryService: ItemSubCategoryService,
        private rmRackCodeService: RmRackPositionService,
        private brandService: MasterBrandService,
        private cycleCheckerRepository: CycleCheckerRepository,
        private cycleCheckeradapter: CycleCheckerAdapter,
        private materialPreperationAdapter: MaterialPreperationAdapter,
        private poItemRepo: PoItemsRepository,
        private storeConsumptionService: StoreConsumptionService,
        private rmRackPositionService: RmRackPositionService,
        private productConversionAdapter: ProductConversionAdapter,
        @InjectRepository(InvntoryLogs)
        private inventoryLogsRepo: Repository<InvntoryLogs>,
    ) { }
    async getAvailableStockQty(stockItemRequest: StockItemRequest): Promise<AvailableStockQtyResponseModel> {
        try {
            const itemCategoryId = stockItemRequest.itemCategoryId;
            const itemId = stockItemRequest.itemId;
            const saleOrder = (stockItemRequest.saleOrderId) ? stockItemRequest.saleOrderId : 0;

            const stockInfo = this.stockRepository.createQueryBuilder("stock").select("stock_id as StockId,SUM(physical_quantity) as physicalQuantity").where("item_id = " + itemId)
                .andWhere("location_id > 0 ")
                ;
            if (stockItemRequest.againstSO) {
                stockInfo.andWhere("saleorder_id = " + saleOrder)
            }
            if (stockItemRequest.unitId) {
                stockInfo.andWhere("unit_id = " + stockItemRequest.unitId);
            }
            const availStock = await stockInfo.groupBy('item_id').getRawOne();

            if (availStock) {
                const data = new AvailStockDto(availStock.physicalQuantity, availStock.StockId, saleOrder);
                const response: AvailableStockQtyResponseModel = new AvailableStockQtyResponseModel(true, 10114, 'Available Stock Quantity retrived successfully', data);
                return response;
            } else {
                throw new ErrorResponse(9999, 'Stock not available');
            }
        } catch (err) {
            throw err;
        }
    }

    async getInventoryStockQty(stockItemRequest: StockItemRequest): Promise<AvailableStockQtyResponseModel> {
        try {
            const itemCategoryId = stockItemRequest.itemCategoryId;
            const itemId = stockItemRequest.itemId;
            // console.log(itemCategoryId)
            // console.log(itemId)
            const availStock = await this.stockRepository.createQueryBuilder("stock").select("stock_id as StockId,SUM(physical_quantity-min_stock-reserved_quantity) as physicalQuantity").where("item_id = " + itemId).andWhere("item_category_id = " + itemCategoryId).andWhere("saleorder_id = 0").getRawOne();
            if (availStock) {
                const data = new AvailStockDto(availStock.physicalQuantity, availStock.StockId, undefined);
                console.log(data);

                const response: AvailableStockQtyResponseModel = new AvailableStockQtyResponseModel(true, 10114, 'Available Stock Quantity retrived successfully', data);
                return response;
            } else {
                throw new AvailableStockQtyResponseModel(false, 9999, 'Stock not available');
            }
        } catch (err) {
            return err;
        }
    }

    /**
     * gets all  Stock data  
     * @returns all the stock details .
     */
    async getAllStockData(plantrolereq?: PlantRoleRequest): Promise<AllStockResponseModel> {
        try {
            const manager = getManager();
            let query = `SELECT s.stock_id AS stockId, s.unit_id AS unitId, ROUND(s.physical_quantity,0) AS physicalQuantity, s.item_category_id AS itemCategoryId, i.item_category AS itemCategory, ii.item_id AS itemId, ii.item_name AS itemName, s.saleOrder_id AS saleOrderId, so.sale_order_no AS  saleOrderNumber, ii.size_id AS sizeId, si.size_name AS sizeName, s.opening_balance AS openingBalance, s.unit_price AS unitPrice, ROUND(s.min_stock) AS minimumStock, s.location_id AS locationId, s.created_user AS createdUser ,  s.updated_user AS updatedUser , s.item_sub_category_id AS itemSubCategoryId, iis.item_sub_category AS itemSubCategoryName, ii.brand AS brandId, iib.brand_name AS brandName, ii.min_grade AS minGrade, ii.max_grade AS maxGrade, ii.pouches,ii.pouch_weight AS pouchWeight, ii.sku_code_id AS variantId, v.variant_code AS variantName, inv.po_number AS poNumber,so.status AS soStatus,uc.unit_name AS unitName, ii.bap_no as bapNumber, CONCAT(ii.pouches,'*',ii.pouch_weight,' ',um.uom_name) AS packStyle,rp.rm_rack_code as rackPosition,ROUND(s.prepared_quantity) AS preparedQuantity,uc.company,um.uom_name as uom FROM ` + appSettings.procure_db + `.stock s
            LEFT JOIN ` + appSettings.masters_db + `.item_categories i ON i.item_category_id = s.item_category_id
            LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories iis ON iis.item_sub_category_id = s.item_sub_category_id 
            LEFT JOIN ` + appSettings.masters_db + `.items ii ON ii.item_id = s.item_id
            LEFT JOIN ` + appSettings.masters_db + `.sizes si ON si.size_id = ii.size_id
            LEFT JOIN ` + appSettings.masters_db + `.master_brands iib ON iib.master_brand_id = ii.brand
            LEFT JOIN ` + appSettings.masters_db + `.sku_codes v ON v.sku_code_id = ii.sku_code_id
            LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = s.saleOrder_id
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = s.unit_id 
            LEFT JOIN ` + appSettings.masters_db + `.uoms um ON um.uom_id = ii.item_uom 
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id = s.saleOrder_id LEFT JOIN ` + appSettings.masters_db + `.rm_rack_position rp ON rp.rm_rack_position_id = s.location_id WHERE  (s.physical_quantity != 0 OR s.prepared_quantity != 0)`;
            if (plantrolereq.unitId) {
                if (plantrolereq.unitId != 5) {
                    query = query + ' and s.unit_id = ' + plantrolereq.unitId;
                }
            }


            query = query + ` order by  iib.brand_name, ii.item_name `;
            const stockDetails: StockDto[] = await manager.query(query);

            if (stockDetails?.length > 0) {

                const response = new AllStockResponseModel(true, 11208, "Stock data Retrived successfully", stockDetails);
                const newLogDto = new LogsDto(1, 'view stock', 'Stock', 0, true, response.internalMessage, '')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getAllStockDataForReport(req?: stockDropdownData): Promise<AllStockResponseModel> {
        console.log(req,"reqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq")
        try {
            const manager = getManager();
            let query = `SELECT 
    s.stock_id AS stockId, 
    s.unit_id AS unitId, ROUND(s.physical_quantity, 0) AS physicalQuantity,inv.act_edl_date AS etd, s.item_category_id AS itemCategoryId, i.item_category AS itemCategory,ii.item_id AS itemId, 
    ii.item_name AS itemName, 
    s.saleOrder_id AS saleOrderId, so.sale_order_no AS saleOrderNumber, ii.size_id AS sizeId, si.size_name AS sizeName, s.opening_balance AS openingBalance, s.unit_price AS unitPrice, 
    ROUND(s.min_stock) AS minimumStock, 
    s.location_id AS locationId, s.created_user AS createdUser, s.updated_user AS updatedUser, s.item_sub_category_id AS itemSubCategoryId, iis.item_sub_category AS itemSubCategoryName, ii.brand AS brandId, 
    iib.brand_name AS brandName, ii.min_grade AS minGrade, ii.max_grade AS maxGrade,ii.pouches, ii.pouch_weight AS pouchWeight, 
    ii.sku_code_id AS variantId, v.variant_code AS variantName,inv.po_number AS poNumber, so.status AS soStatus, uc.unit_name AS unitName, ii.bap_no AS bapNumber,i.item_category AS categoryName, 
    IF(IFNULL(ii.pouches, NULL) AND IFNULL(ii.pouch_weight, NULL), 
        (CONCAT(ii.pouches, '*', ROUND(ii.pouch_weight), ' ', um.uom_name)), '-') AS packStyle, 
    rp.rm_rack_code AS rackPosition, 
    AVG(poi.item_cost) AS averagePrice,
    SUM(poi.item_cost * poi.item_quantity) AS value,ii.item_uom as itemUom,um.uom_name as ItemUomName
FROM ` + appSettings.procure_db + `.stock s
            LEFT JOIN ` + appSettings.masters_db + `.item_categories i ON i.item_category_id = s.item_category_id
            LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories iis ON iis.item_sub_category_id = s.item_sub_category_id 
            LEFT JOIN ` + appSettings.masters_db + `.items ii ON ii.item_id = s.item_id
            LEFT JOIN ` + appSettings.masters_db + `.sizes si ON si.size_id = ii.size_id
            LEFT JOIN ` + appSettings.masters_db + `.master_brands iib ON iib.master_brand_id = ii.brand
            LEFT JOIN ` + appSettings.masters_db + `.sku_codes v ON v.sku_code_id = ii.sku_code_id
            LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = s.saleOrder_id
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = s.unit_id 
            LEFT JOIN ` + appSettings.masters_db + `.uoms um ON um.uom_id = ii.uom_id
            LEFT JOIN ` + appSettings.masters_db + `.rm_rack_position rp ON rp.rm_rack_position_id = s.location_id
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id = s.saleOrder_id 
            LEFT JOIN ` + appSettings.procure_db + ` . purchase_order_items poi ON poi.item_name  = s.item_id
            WHERE s.physical_quantity > 0 `;

            if (req.unitId) {
                query = query + ' AND s.unit_id = ' + req.unitId;
            }
            if (req.saleOrderId) {
                query = query + ` AND s.saleOrder_id = ${req.saleOrderId}`
            }
            if (req.saleOrderId === 0) {
                query = query + ` AND s.saleOrder_id = ${req.saleOrderId}`;
            }
            if (req.itemCategoryId !== undefined && req.itemCategoryId !== null) {
                query = query + ` AND s.item_category_id = ${req.itemCategoryId}`;
            }
            if (req.itemSubCategoryId) {
                query = query + ` AND s.item_sub_category_id =${req.itemSubCategoryId}`;
            }
            if (req.itemId ) {
                query = query + ` AND ii.item_id =${req.itemId }`;
            }
            if (req.brandId) {
                query = query + ` AND iib.master_brand_id =${req.brandId}`;
            }
            if (req.locationId) {
                query = query + ` AND s.location_id =${req.locationId}`
            }
            


            query = query + ' group by  s.stock_id ';
            const stockDetails: StockDto[] = await manager.query(query);

            if (stockDetails?.length > 0) {

                const response = new AllStockResponseModel(true, 11208, "Stock data Retrived successfully", stockDetails);
                return response;
            } else {
                throw new AllStockResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    async getSoDropForStockReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT s.saleorder_id as saleOrderId, inv.po_number AS poNumber , s.unit_id FROM ` + appSettings.procure_db + `.stock s
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id = s.saleOrder_id
        WHERE saleorder_id>0  AND physical_quantity>0`;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY s.saleorder_id `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getItemSubDropForStockReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT s.item_sub_category_id AS itemSubCategoryId , iis.item_sub_category AS itemSubCategoryName , s.unit_id FROM ` + appSettings.procure_db + `.stock s
        LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories iis ON iis.item_sub_category_id = s.item_sub_category_id
        WHERE s.item_sub_category_id> 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY s.item_sub_category_id ORDER BY itemSubCategoryName ASC `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getItemCatDropForStockReport(req?: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT s.item_category_id AS itemCategoryId , ic.item_category AS categoryName , s.unit_id 
        FROM ` + appSettings.procure_db + `.stock s
        LEFT JOIN ` + appSettings.masters_db + `.item_categories ic ON ic.item_category_id = s.item_category_id
        WHERE s.item_category_id> 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY s.item_category_id ORDER BY categoryName ASC `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getItemDropForStockReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT s.item_id AS itemId , i.Item_name AS itemName ,s.unit_id  FROM ` + appSettings.procure_db + `.stock s
        LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = s.item_id
        WHERE s.item_id> 0 and s.item_category_id = 6 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY s.item_id ORDER BY itemName ASC `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getBrandDropForStockReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT ii.brand AS brandId , iib.brand_name AS brandName , s.unit_id FROM ` + appSettings.procure_db + ` .stock s
        LEFT JOIN ` + appSettings.masters_db + ` .items ii ON ii.item_id = s.item_id
        LEFT JOIN ` + appSettings.masters_db + ` .master_brands iib ON iib.master_brand_id = ii.brand
        WHERE ii.brand> 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY ii.brand ORDER BY brandName ASC `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }

    //Assigning existing inventory stock to a saleorder
    async AssignInventoryStock(stockReq: StockInputRequest): Promise<boolean> {
        const manager = new GenericTransactionManager();

        try {
            let totalAssignedQty = 0
            for (const stockReqItem of stockReq.locationWiseStock) {
                let tobeaddedQty = 0
                if (stockReqItem?.ToBeAssignedQuantity >= 0) {
                    tobeaddedQty = stockReqItem.ToBeAssignedQuantity
                } else {
                    tobeaddedQty = stockReqItem.quantity
                }
                totalAssignedQty = Number(totalAssignedQty) + Number(tobeaddedQty)
            }
            const updatePackingBOMStock = await this.saleService.updatePackingBOMGRNData(new BomUpdateRequest(stockReq.itemId, stockReq.saleOrderId, totalAssignedQty, undefined));
            if (!updatePackingBOMStock) {
                throw new ErrorResponse(1111, 'Something went wrong in packing BOM log updation')
            }
            else {
                const updateSOStatus = await this.saleService.updateSOStatus({ saleOrderId: stockReq.saleOrderId, plantId: stockReq.unitId, status: SoStatusEnum.IN_PROGRESS });
                console.log("updateSOStatus" + updateSOStatus);
            }
            // console.log(stockReq)
            await manager.startTransaction();
            let commitFlag = true
            for (const stockReqRec of stockReq.locationWiseStock) {
                const existingStock = await this.stockRepository.findOne({ where: { itemId: stockReq.itemId, saleOrderId: 0, unitId: stockReq.unitId, locationId: stockReqRec.locationId } });
                if (existingStock) {
                    console.log(stockReqRec, 'stockReqRec');
                    console.log(stockReqRec.ToBeAssignedQuantity, 'ToBeAssignedQuantity:');
                    let assignedQty
                    if (stockReqRec?.ToBeAssignedQuantity >= 0) {
                        assignedQty = Number(stockReqRec.ToBeAssignedQuantity)
                    } else {
                        assignedQty = Number(stockReqRec.quantity)
                    }
                    // const assignedQty = (stockReqRec?.ToBeAssignedQuantity) ? Number(stockReqRec.ToBeAssignedQuantity) : Number(stockReqRec.quantity);
                    // if(Number(stockReq.existingQuantity)>=Number(stockReq.requiredQuantity)){
                    //     assignedQty = Number(stockReq.requiredQuantity);
                    // }else{
                    //     assignedQty = Number(stockReq.existingQuantity);
                    // }
                    console.log(assignedQty);
                    const alreadyExist = await this.stockRepository.findOne({ where: { saleOrderId: stockReq.saleOrderId, itemCategoryId: stockReq.itemcategoryId, itemId: stockReq.itemId, unitId: stockReq.unitId, locationId: stockReqRec.locationId } })

                    const stockEntity = new Stock();
                    stockEntity.saleOrderId = stockReq.saleOrderId;
                    stockEntity.itemId = stockReq.itemId;
                    stockEntity.unitId = stockReq.unitId;
                    stockEntity.locationId = existingStock.locationId;
                    stockEntity.itemCategoryId = stockReq.itemcategoryId;
                    stockEntity.itemSubCategoryId = stockReq.itemSubCategoryId;
                    stockEntity.sizeId = existingStock.sizeId;
                    stockEntity.physicalQuantity = assignedQty;
                    stockEntity.unitPrice = existingStock.unitPrice;
                    stockEntity.createdUser = stockReq.createdUser;

                    // saving the log into assign_stock_log table
                    const assignedStockLog = new AssignedStockLog();
                    assignedStockLog.saleOrderId = stockReq.saleOrderId;
                    assignedStockLog.itemId = stockReq.itemId;
                    assignedStockLog.unitId = stockReq.unitId;
                    assignedStockLog.assignedQuantity = assignedQty
                    assignedStockLog.deAssignedQuantity = 0;
                    assignedStockLog.createdUser = stockReq.createdUser;
                    assignedStockLog.packingMaterialId = stockReq.packingmaterialId;
                    assignedStockLog.operationType = LogOperationsEnum.ASSIGNED
                    const logSavingDataStatus = await manager.getRepository(AssignedStockLog).save(assignedStockLog)
                    if (!logSavingDataStatus) {
                        throw new ErrorResponse(11150, 'something went wrong in log saving');
                    }

                    let savedStockEntity;
                    if (alreadyExist) {
                        stockEntity.stockId = alreadyExist.stockId;
                        savedStockEntity = await manager.getCustomRepository(StockRepository).update({ stockId: alreadyExist.stockId }, { physicalQuantity: () => `physical_quantity+${assignedQty}` });
                    } else {
                        savedStockEntity = await manager.getCustomRepository(StockRepository).save(stockEntity);
                    }



                    if (savedStockEntity) {
                        const updatedStock = await manager.getRepository(Stock).update({ itemId: stockReq.itemId, saleOrderId: 0, unitId: stockReq.unitId, locationId: stockReqRec.locationId }, { physicalQuantity: () => `physical_quantity-${assignedQty}` });
                        if (updatedStock.affected) {
                            commitFlag = true

                        } else {
                            commitFlag = false
                            throw new ErrorResponse(11150, 'Something went wrong!Stock Not assigned');

                        }
                    }

                    else {
                        commitFlag = false
                        throw new ErrorResponse(11150, 'Something went wrong!Stock Not assigned');
                    }

                } else {
                    throw new ErrorResponse(11150, 'Items not existed in the stock to assign');

                }
            }
            if (commitFlag) {
                const bomAssignedQtyUpdate: boolean = await this.saleService.UpdateAssignedQty(new BomUpdateRequest(stockReq.itemId, stockReq.saleOrderId, totalAssignedQty))
                if (bomAssignedQtyUpdate) {
                    await manager.completeTransaction()
                    return true
                } else {
                    commitFlag = false
                    throw new ErrorResponse(11150, 'Something went wrong!Stock Not assigned');
                }

            } else {
                await manager.releaseTransaction()
                return false
            }
        } catch (error) {
            manager.releaseTransaction();
            throw error;
        }


    }


    //   }

    //Assigning dummy existing inventory stock to a saleorder
    async AssignDummyPackingInventoryStock(stockReq: StockInputRequest): Promise<boolean> {
        const manager = new GenericTransactionManager();

        try {
            // console.log(stockReq)

            const existingStock = await this.stockRepository.findOne({ where: { itemId: stockReq.itemId, saleOrderId: 0 } });
            if (existingStock) {
                // console.log(existingStock);
                const assignedQty = stockReq.assignedQuantity;
                // if(Number(stockReq.existingQuantity)>=Number(stockReq.requiredQuantity)){
                //     assignedQty = Number(stockReq.requiredQuantity);
                // }else{
                //     assignedQty = Number(stockReq.existingQuantity);
                // }
                await manager.startTransaction();
                const alreadyExist = await this.stockRepository.findOne({ where: { saleOrderId: stockReq.saleOrderId, itemCategoryId: stockReq.itemcategoryId, itemId: stockReq.itemId } })

                const stockEntity = new Stock();
                stockEntity.saleOrderId = stockReq.saleOrderId;
                stockEntity.itemId = stockReq.itemId;
                stockEntity.unitId = existingStock.unitId;
                stockEntity.locationId = existingStock.locationId;
                stockEntity.itemCategoryId = stockReq.itemcategoryId;
                stockEntity.sizeId = existingStock.sizeId;
                stockEntity.physicalQuantity = assignedQty;
                stockEntity.unitPrice = existingStock.unitPrice;
                stockEntity.createdUser = 'Admin';
                let savedStockEntity;
                if (alreadyExist) {
                    stockEntity.stockId = alreadyExist.stockId;
                    savedStockEntity = await manager.getCustomRepository(StockRepository).update({ stockId: alreadyExist.stockId }, { physicalQuantity: () => `physical_quantity+${assignedQty}` });
                } else {
                    savedStockEntity = await manager.getCustomRepository(StockRepository).save(stockEntity);
                }

                if (savedStockEntity) {
                    //need to write logic for saving of log
                    const updatedStock = await manager.getRepository(Stock).update({ itemId: stockReq.itemId, saleOrderId: 0 }, { physicalQuantity: () => `physical_quantity-${assignedQty}` });
                    if (updatedStock) {
                        const bomAssignedQtyUpdate = await this.saleService.saveDummyPackmaterial(new DummyPackBomItemsRequest(stockReq.itemId, stockReq.saleOrderId, stockReq.itemcategoryId, stockReq.itemSubCategoryId, stockReq.assignedQuantity, stockReq.assignedQuantity, undefined))
                        if (bomAssignedQtyUpdate) {
                            manager.completeTransaction();
                            return true;
                        } else {
                            throw new ErrorResponse(11150, 'Something went wrong!Stock Not assigned');

                        }
                    } else {
                        throw new ErrorResponse(11150, 'Something went wrong!Stock Not assigned');

                    }
                } else {
                    throw new ErrorResponse(11150, 'Something went wrong!Stock Not assigned');
                }

            } else {
                throw new ErrorResponse(11150, 'Items not existed in the stock to assign');

            }
        } catch (error) {
            manager.releaseTransaction();
            throw error;
        }


    }


    async updateRemovedAssignedQtyForSo(stockReq: ItemRemovedQty): Promise<CommonResponse> {
        console.log('-----ok-------')
        let manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            let updateFlag = true
            for (const stockreqItem of stockReq.locationWiseStock) {
                let existingStock = await this.stockRepository.findOne({ where: { itemId: stockReq.itemId, saleOrderId: 0, locationId: stockreqItem.locationId } });
                if (existingStock) {
                    console.log(stockReq);
                    console.log("**Stock Found**");
                    const alreadyExist = await this.stockRepository.findOne({ where: { saleOrderId: stockReq.saleOrderId, itemId: stockReq.itemId, locationId: stockreqItem.locationId } });
                    let updateStock;

                    if (alreadyExist) {
                        if (alreadyExist.physicalQuantity >= stockReq.removedQuantity) {
                            const reAssignQty = Number(stockreqItem?.ToBeAssignedQuantity ? stockreqItem.ToBeAssignedQuantity : stockreqItem.quantity)
                            updateStock = await manager.getCustomRepository(StockRepository).update({ stockId: alreadyExist.stockId }, { physicalQuantity: () => `physical_quantity-${reAssignQty}` });

                            const updatedSoStock = await manager.getRepository(Stock).update({ itemId: stockReq.itemId, saleOrderId: 0, locationId: stockreqItem.locationId }, { physicalQuantity: () => `physical_quantity+${reAssignQty}` });

                            if (updatedSoStock.affected) {
                                const assignedStockLog = new AssignedStockLog();
                                assignedStockLog.saleOrderId = stockReq.saleOrderId;
                                assignedStockLog.itemId = stockReq.itemId;
                                assignedStockLog.unitId = stockReq.unitId;
                                assignedStockLog.assignedQuantity = 0
                                assignedStockLog.deAssignedQuantity = reAssignQty;
                                assignedStockLog.createdUser = stockReq.createdUser;
                                assignedStockLog.packingMaterialId = stockReq.packingMaterialId
                                assignedStockLog.operationType = LogOperationsEnum.DE_ASSIGNED
                                const assignedStockLogSave = await manager.getRepository(AssignedStockLog).save(assignedStockLog)
                                if (assignedStockLogSave) {
                                    updateFlag = true
                                } else {
                                    updateFlag = false
                                    break
                                }

                            } else {
                                throw new ErrorResponse(11150, 'something went wrong');
                            }
                        } else {
                            throw new ErrorResponse(11150, 'Items not existed in the stock to remove');
                        }
                    }
                }
            }
            if (updateFlag) {
                await manager.completeTransaction();
                return new CommonResponse(true, 9999, 'Data Updated Successfully');
            } else {
                manager.releaseTransaction();
                throw new ErrorResponse(11150, 'Something went wrong in updation');;
            }
        } catch (error) {
            manager.releaseTransaction();
            throw error;
        }
    }

    async getAvailableStockSosForConsumption(req?: UnitRequest): Promise<SaleOrderDropDownResponseModel> {
        try {
            const manager = getManager();
            let query = `SELECT s.saleorder_id as saleOrderId, so.sale_order_no as saleOrderNumber, inv.po_number as poNumber FROM ` + appSettings.procure_db + `.stock s 
                LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=s.saleorder_id 
                LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id
                where physical_quantity > 0 AND saleorder_id != 0
                `;

            if (req.unitId && req.unitId != GlobalVariableValues.headOfficeUnitId) {
                query += `  AND s.unit_id=` + req.unitId;
            }
            query += ` group by s.saleorder_id order by s.saleorder_id`

            const saleOrders: SaleOrderDropDownDto[] = await manager.query(query);
            if (saleOrders) {
                return new SaleOrderDropDownResponseModel(true, 1111, 'Sale Orders Retrieved Successfully', saleOrders)
            } else {
                throw new ErrorResponse(1111, 'Failed to Get Sale Orders');
            }
        } catch (error) {
            return error
        }
    }

    async getAvailableStockItemSos(req?: ItemIDRequest): Promise<SaleOrderDropDownResponseModel> {
        try {
            const manager = getManager();
            let query = `SELECT s.saleorder_id as saleOrderId, so.sale_order_no as saleOrderNumber, inv.po_number as poNumber FROM ` + appSettings.procure_db + `.stock s 
                LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=s.saleorder_id 
                LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id
                where physical_quantity > 0 AND saleorder_id != 0
                and item_id = `+ req.itemId;

            if (req.unitId) {
                query += `  AND s.unit_id=` + req.unitId;
            }
            query += `  group by s.saleorder_id order by s.saleorder_id`;

            const saleOrders: SaleOrderDropDownDto[] = await manager.query(query);
            if (saleOrders.length > 0) {
                return new SaleOrderDropDownResponseModel(true, 1111, 'Sale Orders Retrieved Successfully', saleOrders)
            } else {
                return new SaleOrderDropDownResponseModel(false, 9999, 'No saleorders with this item')

            }
        } catch (error) {
            return error
        }
    }

    async getAvailableStockSosForReturns() {
        try {
            const soIds = await this.stockRepository.createQueryBuilder("stock").select("saleorder_id as saleOrderId").andWhere("saleorder_id != 0").groupBy('saleorder_id').getRawMany();
            if (soIds) {
                const saleOrders: SaleOrderFewDetailsDto[] = [];
                for (const id of soIds) {
                    const soReq: saleOrder = {
                        saleOrderId: id.saleOrderId
                    }

                    const saleOrderDetails = await this.saleService.getSaleOrderFewDetailsForSoId(soReq);
                    if (!saleOrderDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Sale Order');
                    }
                    saleOrders.push(saleOrderDetails);
                }
                return new SaleOrderDropDownResponseModel(true, 1111, 'Sale Orders Retrieved Successfully', saleOrders)
            } else {
                throw new ErrorResponse(1111, 'Failed to Get Sale Orders');
            }
        } catch (error) {
            return error
        }
    }

    async getAvailableStockForSO(saleOrderReq: SaleOrderIdRequest): Promise<StockQtyResponseModel> {
        try {
            const totalsQty = await this.stockRepository.createQueryBuilder("stock").select("saleorder_id as saleOrderId, stock_id as stockId, sum(physical_quantity) as totQty").andWhere("saleorder_id = " + saleOrderReq.saleOrderId).groupBy('saleorder_id').getRawOne();
            console.log(totalsQty);
            if (totalsQty) {
                const data = new StockResponseDto(totalsQty.saleOrderId, totalsQty.stockId, totalsQty.totQty);
                return new StockQtyResponseModel(true, 1001, 'Rm stock retrived successfully', data);
            }
            else {
                return new StockQtyResponseModel(false, 1010, 'No data found');
            }
        } catch (error) {
            return error
        }
    }


    async getAvailableStockItemCategories(req: UnitRequest): Promise<ItemCategoriesDropDownResponseModel> {
        try {
            const itemCategoryIds: ItemCategoryDropDownDto[] = await this.stockRepository.createQueryBuilder("stock").select("item_category_id as itemCategoryId").where(`unit_id = '${req.unitId}' and physical_quantity > 0 and saleorder_id=0 and item_category_id=6`).groupBy('item_category_id').orderBy('item_category_id').getRawMany();

            if (itemCategoryIds && itemCategoryIds.length) {
                for (const id of itemCategoryIds) {
                    const itemCategoryData = await this.itemCategoryService.getItemCategoryById({ itemCategoryId: id.itemCategoryId });
                    id.itemCategoryId = itemCategoryData.itemCategoryId;
                    id.itemCategory = itemCategoryData.itemCategory;
                    id.itemCategoryCode = itemCategoryData.itemCategoryCode;
                }
                return new ItemCategoriesDropDownResponseModel(true, 1111, 'Item Categories Retrieved Successfully', itemCategoryIds)
            } else {
                throw new ErrorResponse(1111, 'Failed to Get Item Categories');
            }
        } catch (error) {
            return error
        }
    }

    async getAvailableStockItemSubCategories(req: ItemCategoryIdReq): Promise<ItemSubCategoriesDropDownResponse> {
        try {
            const manager = getManager();
            let query = `SELECT s.item_sub_category_id as itemSubCategoryId, isc.item_sub_category as  itemSubCategory, category_code as itemSubCategoryCode FROM ` + appSettings.procure_db + `.stock s 
                LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id=s.item_sub_category_id 
                where physical_quantity > 0`;

            if (req.unitId) {
                query += `  AND s.unit_id=` + req.unitId;
            }
            if (req.saleOrderId) {
                query += ` AND saleorder_id=${req.saleOrderId}`;
            } else {
                query += ' AND saleorder_id=0';
            }
            query += ' group by s.item_sub_category_id';

            const itemSubCategoryIds: ItemSubCategoryDropDownDto[] = await manager.query(query);
            if (itemSubCategoryIds && itemSubCategoryIds.length) {
                return new ItemSubCategoriesDropDownResponse(true, 1111, 'Item Sub Categories Retrieved Successfully', itemSubCategoryIds)
            } else {
                throw new ErrorResponse(1111, 'Failed to Get Item Sub Categories');
            }
        } catch (error) {
            return error
        }
    }

    async getAvailableStockTransferItems(req: CategorySubCategoryReq): Promise<ItemsDropDownResponseModel> {
        try {
            const manager = getManager();
            let query = `SELECT s.item_id as itemId, i.item_name as itemName, i.size_id as sizeId,si.size_name as sizeName,SUM(s.physical_quantity) as physicalQuantity  FROM ` + appSettings.procure_db + `.stock s 
                LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id=s.item_id 
                LEFT JOIN `+ appSettings.masters_db + `.sizes si ON si.size_id=i.size_id 
                where i.item_category_id=${req.itemCategoryId} AND i.item_sub_category_id=`+ req.itemSubCategoryId;

            if (req.unitId) {
                query += `  AND s.unit_id=` + req.unitId;
            }

            if (req.saleOrderId) {
                query += ` AND saleorder_id=${req.saleOrderId}`;
            } else {
                query += ' AND saleorder_id=0';
            }

            query += ' AND s.physical_quantity>0 group by s.item_id';

            const items: ItemsDropDownDto[] = await manager.query(query);

            if (items && items.length) {
                return new ItemsDropDownResponseModel(true, 1111, 'Items Retrieved Successfully', items)
            } else {
                throw new ErrorResponse(1111, 'Failed to Get Items');
            }
        } catch (error) {
            return error
        }
    }


    async getAvailableStockItems(req: CategorySubCategoryReq): Promise<ItemsDropDownResponseModel> {
        try {
            const itemList = this.stockRepository.createQueryBuilder("stock").select("item_id as itemId").where(`unit_id = ${req.unitId} and physical_quantity > 0 and item_category_id = ${req.itemCategoryId} and item_sub_category_id = ${req.itemSubCategoryId}`);
            if (req.saleOrderId) {
                itemList.andWhere(`saleorder_id=${req.saleOrderId}`);
            } else {
                itemList.andWhere('saleorder_id=0');
            }
            const items: ItemsDropDownDto[] = await itemList.groupBy('item_id').orderBy('item_id').getRawMany();
            if (items && items.length) {
                for (const id of items) {
                    // get item details for item id 
                    const itemReq = new ItemRequest(id.itemId);
                    const itemDetails = await this.itemService.getItemById(itemReq);
                    if (!itemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item');
                    }

                    id.itemId = itemDetails.itemId;
                    id.itemName = itemDetails.itemName;
                }

                return new ItemsDropDownResponseModel(true, 1111, 'Items Retrieved Successfully', items)
            } else {
                throw new ErrorResponse(1111, 'Failed to Get Items');
            }
        } catch (error) {
            return error
        }
    }


    async getAvailableTransferStockQty(req: QtyRequest): Promise<CommonResponse> {
        try {
            const itemQtyInfo = await this.stockRepository.createQueryBuilder("stock").select("SUM(physical_quantity) as physicalQuantity,SUM(prepared_quantity) AS preparedQuantity, unit_price as unitPrice").where(`unit_id = ${req.unitId} and item_category_id = ${req.itemCategoryId} and item_sub_category_id = ${req.itemSubCategoryId} and item_id = ${req.itemId}`);
            if (req.saleOrderId) {
                itemQtyInfo.andWhere(`saleorder_id=${req.saleOrderId}`);
            } else {
                itemQtyInfo.andWhere('saleorder_id=0');
            }
            if (req.isPreparedMaterial === 'yes') {
                itemQtyInfo.andWhere('location_id = 0');
            }
            else {
                itemQtyInfo.andWhere('location_id > 0').andWhere('physical_quantity > 0');
            }

            const itemQty = await itemQtyInfo.orderBy('size_id').getRawOne();

            if (itemQty) {
                return new CommonResponse(true, 1111, 'QTY Found', itemQty)
            } else {
                return new CommonResponse(false, 1111, 'QTY Not Found')
            }
        } catch (error) {
            return error
        }
    }



    async getAvailableStockSoItems(saleOrderReq: SaleOrderIdRequest): Promise<GetAvailableStockResponse> {
        try {
            const availableSoItems: PackingSTItems[] = await this.stockRepository.createQueryBuilder("stock").select("saleorder_id as saleOrderId, item_category_id as itemCategoryId, item_sub_category_id as itemSubCategoryId, item_id as itemId,size_id as sizeId, physical_quantity as issuedQty, unit_price as unitPrice").where(`unit_id =${saleOrderReq.plantId} and physical_quantity > 0`).andWhere("saleorder_id = " + saleOrderReq.saleOrderId).getRawMany();
            if (availableSoItems) {
                for (const item of availableSoItems) {
                    const itemCategoryReq = new ItemCategoryReq(item.itemCategoryId);
                    const itemCategoryDetails = this.itemCategoryService.getItemCategoryById(itemCategoryReq);
                    if (!itemCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }
                    const itemReq = new ItemRequest(item.itemId);
                    const itemDetails = this.itemService.getItemById(itemReq);
                    if (!itemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item');
                    }
                    const itemSubCategoryReq = new ItemSubCategoryRequest(item.itemSubCategoryId);
                    const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
                    if (!itemSubCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }

                    await Promise.all([itemCategoryDetails, itemDetails, itemSubCategoryDetails]).then(res => {
                        const itemCategory = (res[0]) ? res[0] : null;
                        const itemSubCategory = (res[2]) ? res[2] : null;
                        const itemData = (res[1]) ? res[1] : null;
                        item.itemCategory = JSON.stringify(itemCategory);
                        item.itemSubCategory = JSON.stringify(itemSubCategory);
                        item.item = JSON.stringify(itemData);
                        item.availableQty = item.issuedQty;
                    })
                }
                return new GetAvailableStockResponse(true, 1001, 'so items stock retrived successfully', availableSoItems);
            }
            else {
                return new GetAvailableStockResponse(false, 1010, 'No data found');
            }
        } catch (error) {
            return error
        }
    }


    async stockEntry(dto: StockDto, isCycleChecker?: boolean): Promise<CommonResponse> {
        try {
            let result;
            const stock = await this.stockRepository.findOne({ where: { unitId: dto.unitId, itemId: dto.itemId, locationId: dto.locationId, saleOrderId: 0 } })
            if (!(stock) || isCycleChecker) {
                const stockData = new Stock();
                stockData.itemId = dto.itemId;
                stockData.itemCategoryId = 6;
                stockData.itemSubCategoryId = dto.itemSubCategoryId;
                stockData.physicalQuantity = dto.physicalQuantity;
                stockData.openingBalance = 0.000;
                stockData.unitPrice = 0.000;
                stockData.minimumStock = 0.000;
                stockData.locationId = dto.locationId;
                stockData.saleOrderId = 0;
                stockData.reservedQuantity = 0.000;
                if (!isCycleChecker) {
                    stockData.intransitQuantity = 0.000;
                }
                stockData.unitId = dto.unitId;
                stockData.sizeId = dto.sizeId
                stockData.createdUser = dto.createdUser;
                if (stockData.stockId) {
                    stockData.stockId = dto.stockId;
                    stockData.updatedUser = dto.createdUser;
                }
                stockData.stockId = stock?.stockId
                result = await this.stockRepository.save(stockData)

            } else {
                result = await this.stockRepository.update({ unitId: dto.unitId, itemId: dto.itemId, locationId: dto.locationId, saleOrderId: 0 }, { physicalQuantity: () => `physical_quantity+${dto.physicalQuantity}` })
            }
            if (result) {
                if (!isCycleChecker) {
                    const locationStatusUpdate = await this.rmRackCodeService.updateRmLocationStatus(new RMrackStatusRequest(dto.locationId, RmOccupancyEnum.PARTIALLY_OCCUPIED, dto.unitId, dto.itemSubCategoryId, dto.brandId))
                    if (!locationStatusUpdate.status) {
                        throw new ErrorResponse(1010, 'something went wrong');
                    }
                }
                const data = new CommonResponse(true, 11111, 'Stock Created sucessfully')
                const newLogDto = new LogsDto(1, 'created', 'Stock', stock.stockId, true, data.internalMessage, stock.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return data
            } else {
                throw new ErrorResponse(1010, 'Error in creating stock');
            }
        } catch (error) {
            return error
        }
    }

    async stockConversion(dto: ProductConversionModel): Promise<CommonResponse> {
        const transmanager = new GenericTransactionManager();
        try {
            await transmanager.startTransaction()

            // subtract converting quantity  from the from-item
            const fromItemQty = await this.stockRepository.findOne({ where: { saleOrderId: dto.fromSaleOrderId, itemId: dto.toSaleOrderItemId, locationId: dto.locationId, unitId: dto.unitId } });

            const updatedFromItemQty = Math.round(fromItemQty.physicalQuantity) - dto.conversionQuantity;

            const updateFromItemQty = await transmanager.getCustomRepository(StockRepository).update({ saleOrderId: dto.fromSaleOrderId, itemId: dto.fromSaleOrderItemId, locationId: dto.locationId, unitId: dto.unitId }, { physicalQuantity: updatedFromItemQty, updatedUser: dto.createdUser })
            if (!updateFromItemQty.affected) {
                throw new ErrorResponse(1111, 'Failed to update from items stock')
            }


            // add converting quantity to the to-item
            const toItemQty = await this.stockRepository.findOne({ where: { saleOrderId: dto.toSaleOrderId ? dto.toSaleOrderId : 0, itemId: dto.toSaleOrderItemId, locationId: dto.locationId, unitId: dto.unitId } })
            if (toItemQty) {
                console.log('--update--')
                const updatedToItemQty = Math.round(toItemQty.physicalQuantity) + dto.conversionQuantity
                const updateToItemQty = await transmanager.getCustomRepository(StockRepository).update({ saleOrderId: dto.toSaleOrderId ? dto.toSaleOrderId : 0, itemId: dto.toSaleOrderItemId, locationId: dto.locationId, unitId: dto.unitId }, { physicalQuantity: updatedToItemQty, updatedUser: dto.createdUser })
                if (!updateToItemQty.affected) {
                    throw new ErrorResponse(1111, 'Failed to update Stock')

                }
            } else {

                const convertToStockEntity = await this.productConversionAdapter.convertDtoToEntity(dto)
                const updateToItemQty = await transmanager.getCustomRepository(StockRepository).save(convertToStockEntity)
                if (!updateToItemQty) {
                    throw new ErrorResponse(1111, 'Failed to update Stock')

                }
            }
            // updating bom
            const req = new ProductConversionReq
            req.conversionType = dto.conversionType
            req.itemId = dto.fromSaleOrderItemId;
            req.saleOrderId = dto.fromSaleOrderId;
            req.qty = dto.conversionQuantity;
            req.toSaleOrderId = dto.toSaleOrderId
            req.soStatus = dto.soStatus
            console.log('reqqq', req)

            if (dto.conversionType == ConversionType.saleorder_to_saleorder || (dto.conversionType == ConversionType.saleorder_to_bulk && dto.soStatus != SoStatusEnum.CLOSED)) {
                const updateToItemBom = await this.saleService.updateProductConversionQty(req)
                if (!updateToItemBom.status) {
                    throw new ErrorResponse(1111, 'Failed to update BOM')
                }
            }

            //updating from-item and to-item qunatities and inserting details into product_conversion_log table
            const productConversionLog = new ProductConversion()
            productConversionLog.conversionType = dto.conversionType;
            productConversionLog.fromSaleOrderId = dto.fromSaleOrderId;
            productConversionLog.fromSaleOrderItemId = dto.fromSaleOrderItemId;
            productConversionLog.fromQuantity = 0;
            productConversionLog.toSaleOrderId = dto.toSaleOrderId ? dto.toSaleOrderId : 0;
            productConversionLog.toSaleOrderItemId = dto.toSaleOrderItemId ? dto.toSaleOrderItemId : 0;
            productConversionLog.conversionQty = dto.conversionQuantity;
            productConversionLog.reason = dto.reason ? dto.reason : '';
            productConversionLog.createdAt = dto.createdAt;
            productConversionLog.createdUser = dto.createdUser;
            productConversionLog.locationId = dto.locationId;
            productConversionLog.unitId = dto.unitId;
            const saveLog = await transmanager.getRepository(ProductConversion).save(productConversionLog)
            if (saveLog) {


                transmanager.completeTransaction()
                const data = new CommonResponse(true, 11111, 'Product converted sucessfully')
                const newLogDto = new LogsDto(1, 'product converted', 'Stock', saveLog.productConversionId, true, data.internalMessage, saveLog.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return data
            }
        }
        catch (error) {
            console.log(error)
            await transmanager.releaseTransaction()
            return error
        }

    }

    async getStockDetailsForItemId(req: ItemIDRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT s.item_id as itemId,s.stock_id as stockId,s.physical_quantity as physicalQuantity,s.saleorder_id as saleOrderId FROM ` + appSettings.procure_db + `.stock s
                WHERE s.item_id = ` + req.itemId + ` and s.unit_id = ` + req.unitId
            const queryResult = await manager.query(query)
            if (queryResult) {
                return new CommonResponse(true, 1111, 'item details retrived', queryResult)
            } else {
                return new CommonResponse(false, 1010, 'No Items Found')
            }
        } catch (err) {
            return err
        }
    }

    async stockEdit(dto: StockDto): Promise<CommonResponse> {
        try {
            const update = await this.stockRepository.update({ stockId: dto.stockId }, { physicalQuantity: dto.physicalQuantity, updatedUser: dto.createdUser })
            if (update.affected) {
                return new CommonResponse(true, 1111, 'Quantity details updated')
            } else {
                return new CommonResponse(false, 1010, 'Failed to update quantity')
            }


        } catch (error) {
            throw error
        }
    }

    async getavailbleItemsInStock(req: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            let query;
            const manager = getManager()
            query = 'SELECT  s.item_id as itemId ,i.item_name as itemName,i.item_sub_category_id as itemSubCategoryId,i.brand as brandId,s.location_id as locationId from ' + appSettings.procure_db + '.stock s left join ' + appSettings.masters_db + '.items i on i.item_id = s.item_id where s.physical_quantity > 0  and s.saleorder_id = ' + req.saleOrderId;
            if (req.itemSubCategoryId) {
                query = query + ` and s.item_sub_category_id = ` + req.itemSubCategoryId
            }
            if (req?.plantId > 0) {
                query = query + ` and s.unit_id = ` + req.plantId
            }
            if (req?.isPreperationRequired == 'YES') {
                query = query + ` and i.is_preperation_required = '` + GlobalStatus.YES + `'`
            }
            query = query + ` group by s.item_id`
            const data = await manager.query(query)
            console.log(query)
            if (data.length > 0) {
                return new CommonResponse(true, 1111, 'Items retreived', data)
            } else {

                return new CommonResponse(false, 1111, 'No items found in stock')
            }
        } catch (error) {

            return error
        }
    }


    async getPhysicalQuantityForItemId(req: ItemIDRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query

        if (req.locationId > 0) {
            query = `SELECT s.physical_quantity as physicalQuantity,s.stock_id as stockId from ` + appSettings.procure_db + `.stock s where s.item_id = ` + req.itemId + ` and s.saleorder_id = ` + req.saleOrderId + ` and location_id = ${req.locationId}`
        } else {
            if (req.stockType == stockTypeEnum.Dummy || req.stockType == stockTypeEnum.SuperDummy) {
                query = `SELECT SUM(s.physical_quantity) as physicalQuantity,s.stock_id as stockId from ` + appSettings.procure_db + `.stock s where s.item_id = ` + req.itemId + ` and s.saleorder_id = 0`
            }
            if (req.stockType == stockTypeEnum.SaleOrder) {
                query = `SELECT SUM(s.physical_quantity) as physicalQuantity,s.stock_id as stockId from ` + appSettings.procure_db + `.stock s where s.item_id = ` + req.itemId + ` and s.saleorder_id = ` + req.saleOrderId

            }
        }
        const data = await manager.query(query)
        if (data[0].physicalQuantity > 0) {
            return new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
        } {
            return new CommonResponse(false, 1111, 'No stock found')
        }
    }

    async getNoLocationPhysicalQuantity(req: ItemIDRequest): Promise<CommonResponse> {
        const manager = getManager()
        const query = `SELECT s.physical_quantity as physicalQuantity,s.stock_id as stockId from ` + appSettings.procure_db + `.stock s where s.location_id = 0 and s.item_id = ` + req.itemId + ` and s.saleorder_id = ` + req.saleOrderId + ` and unit_id = ` + req.unitId
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
        } {
            return new CommonResponse(false, 1111, 'No data found')
        }
    }

    async cancelledSoStockUpdate(req: SaleOrderIdRequest): Promise<CommonResponse> {
        const stockExistWithSO = await this.stockRepository.findOne({ where: { saleOrderId: req.saleOrderId, unitId: req.plantId } })
        if (stockExistWithSO) {
            console.log('jjjj')

            const updateSO = await this.moveLeftOverQtyIntoBulk(req)
            if (updateSO.status) {
                return new CommonResponse(true, 5555, 'left over qty moved into bulk')
            } else {
                return new CommonResponse(false, 9999, 'some thing went wrong')
            }
            console.log('uuuuu')
            // console.log(updateSO)
        } else {
            return new CommonResponse(true, 5555, 'NO stock exist with so')
        }

    }

    async moveLeftOverQtyIntoBulk(req: SaleOrderIdRequest): Promise<CommonResponse> {
        const transmanager = new GenericTransactionManager();
        try {
            const updateflag = new Set<boolean>()
            await transmanager.startTransaction()
            // let query = `SELECT s.item_id as itemId,s.stock_id as stockId,s.size_id as sizeId,s.physical_quantity as physicalQuantity,s.saleorder_id as saleOrderId FROM ` + appSettings.procure_db  + `.stock s where saleorder_id =`+req.saleOrderId+` and s.physical_quantity > 0`
            // // const leftoverstockData = await manager.query(query)
            const leftoverstockData = await this.stockRepository.find({ where: { saleOrderId: req.saleOrderId, physicalQuantity: MoreThan(0) } })

            for (const item of leftoverstockData) {
                if (item.physicalQuantity > 0) {
                    const existingStock = await this.stockRepository.findOne({ where: { saleOrderId: 0, itemId: item.itemId } })
                    let stockUpdate
                    if (existingStock) {
                        stockUpdate = await transmanager.getCustomRepository(StockRepository).update({ stockId: existingStock.stockId }, { physicalQuantity: () => `physical_quantity+${item.physicalQuantity}` });
                        if (stockUpdate.affected) {
                            const soStockUpdate = await transmanager.getCustomRepository(StockRepository).update({ stockId: item.stockId }, { physicalQuantity: 0 })
                            if (!soStockUpdate) {
                                updateflag.add(false)
                                break
                            }
                        }
                    } else {
                        stockUpdate = await transmanager.getCustomRepository(StockRepository).update({ stockId: item.stockId }, { saleOrderId: 0 })
                    }
                    if (stockUpdate.affected) {
                        updateflag.add(true)
                    } else {
                        updateflag.add(false)
                        break
                    }
                }
            }
            if (!(updateflag.has(false))) {
                transmanager.completeTransaction()
                return new CommonResponse(true, 5555, 'left over qty moved into bulk')
            } else {
                throw new ErrorResponse(4444, 'something went wrong')
            }
        } catch (err) {
            await transmanager.releaseTransaction()
            throw err
        }
    }



    async getFromPosForProductConversion(req?: ProductConversionReq): Promise<CommonResponse> {
        let query
        const manager = getManager()
        if (req.conversionType == ConversionType.saleorder_to_saleorder) {
            query = `SELECT st.saleorder_id as saleOrderId,sid.po_number as poNumber,so.status from ${appSettings.procure_db}.stock st
        LEFT JOIN ${appSettings.sales_db}.so_invoice_details sid on sid.sale_order_id = st.saleorder_id
        left join ${appSettings.sales_db}.sale_order so on so.sale_order_id = st.saleorder_id
        where st.unit_id = ${req.unitId} and st.saleorder_id > 0 and st.physical_quantity > 0  group by st.saleorder_id`
        } else {
            query = `SELECT st.saleorder_id as saleOrderId,sid.po_number as poNumber,so.status from ${appSettings.procure_db}.stock st
        LEFT JOIN ${appSettings.sales_db}.so_invoice_details sid on sid.sale_order_id = st.saleorder_id
        left join ${appSettings.sales_db}.sale_order so on so.sale_order_id = st.saleorder_id
        where st.unit_id = ${req.unitId} and st.physical_quantity > 0  and st.saleorder_id > 0 group by st.saleorder_id`
        }
        const data = await manager.query(query);
        if (data && data.length) {
            return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
        } else {
            return new CommonResponse(false, 1111, "No Data")
        }
    }

    async getPoNumberForProductConversion(req: ProductConversionReq): Promise<CommonResponse> {
        console.log(req, '--req--')
        try {
            let query
            const manager = getManager()
            query = `select sid.sale_order_id as saleOrderId,sid.po_number as poNumber  from ${appSettings.sales_db}.so_invoice_details sid
           left join ${appSettings.sales_db}.bom_details b on b.sale_order_id  = sid.sale_order_id
           left join ${appSettings.sales_db}.sale_order so on so.sale_order_id = sid.sale_order_id

           where b.status != '${StatusEnum.CLOSED}' and sid.sale_order_id <> ${req.saleOrderId}  and b.packing_category is not null and b.item_id = ${req.itemId} and sid.processing_unit = ${req.unitId} and so.status IN ('OPEN','INPROGRESS') group by b.sale_order_id`
            const data = await manager.query(query);
            if (data && data.length) {
                return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
            } else {
                return new CommonResponse(false, 1111, "Saleorders not found with the selected item in BOM")
            }
        } catch (error) {
            throw error
        }
    }

    async getPackingItemsForSoId(req: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            let query;
            query = 'SELECT  s.item_id as itemId ,i.item_name as itemName,i.item_sub_category_id as itemSubCategoryId  from ' + appSettings.sales_db + '..so_invoice_details s left join ' + appSettings.masters_db + '.items i on i.item_id = s.item_id  and s.saleorder_id = ' + req.saleOrderId;
            const data = await manager.query(query);
            if (data && data.length) {
                return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
            } else {
                return new CommonResponse(false, 1111, "No Data")
            }
        } catch (error) {
            throw error
        }
    }
    async getToItemsForProductConversion(req: ProductConversionReq): Promise<CommonResponse> {
        const manager = getManager()
        let query;
        query = `select i.item_name as itemName,i.item_id as itemId from ${appSettings.sales_db}.bom_details b
            left join ${appSettings.masters_db}.items i on i.item_id = b.item_id where  b.status != 'CLOSED'  and b.packing_category is not null and b.sale_order_id = ${req.saleOrderId} and b.item_id = ${req.itemId}`
        const data = await manager.query(query);
        if (data && data.length) {
            return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
        } else {
            return new CommonResponse(false, 1111, "No Data")
        }
    }

    async getTransferredSosDataForStockGrid(req?: UnitRequest) {

        const transferredSoIds = await this.saleService.getTransferredSaleOrders();
        console.log('transferedSos', transferredSoIds)
        if (transferredSoIds.status) {
            //below line using to convert array of objets to array of properties
            const arrayOfSoIds = transferredSoIds.data.map(({ saleOrderId }) => saleOrderId)
            let concatString = ''
            console.log('array', arrayOfSoIds)
            if (req) {

                if (req.unitId && req.unitId != 5) {
                    concatString = `and g.unit_id = ` + req.unitId;
                }
            }
            const manager = getManager();
            const query = `SELECT s.stock_id as stockId,s.saleorder_id as saleOrderId,s.item_id as itemId,sid.po_number as poNumber ,i.item_name as itemName,b.brand_name as brandName,ROUND(s.physical_quantity,0) as physicalQuantity,uc.unit_name as unitName,rp.rm_rack_code as rackPosition ,uc.company from ` + appSettings.procure_db + `.stock s
          left join ` + appSettings.sales_db + `.so_invoice_details sid on sid.sale_order_id = s.saleorder_id 
          left join ` + appSettings.masters_db + `.items i on i.item_id = s.item_id
          left join ` + appSettings.masters_db + `.master_brands b on b.master_brand_id = i.brand
          left join ` + appSettings.masters_db + `.unitcodes uc on uc.unit_code_id = s.unit_id
          LEFT JOIN ` + appSettings.masters_db + `.rm_rack_position rp ON rp.rm_rack_position_id = s.location_id where  s.saleorder_id IN (` + arrayOfSoIds.toString() + `) ` + concatString;
            const stockData = await manager.query(query);
            if (stockData && stockData.length > 0) {
                const newLogDto = new LogsDto(1, 'Stock view', 'stock', 0, true, 'Stock Details Retrieved Successfully', '')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return new CommonResponse(true, 1525, 'Stock Details Retrieved Successfully', stockData);
            } else {
                throw new CommonResponse(false, 9999, 'No Data Found');
            }
        } else {
            throw new CommonResponse(false, 9999, 'No Transferred SaleOrders  Found');
        }
    }

    async getPackingBomReport(req?: PackingBomRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT sot.sale_order_id,soi.po_number as poNum,uc.unit_name as unit,soi.act_edl_date as etd,IF(so_type='Dispatch',DATEDIFF(DATE(soi.act_edl_date),DATE(NOW())),'0') as targetDays,so.so_type as soType, sot.pm_status as pmStatus,SUM(IF(bd.required_qty=0,1,0)) AS closedItems,COUNT(*)-SUM(IF(bd.required_qty=0,1,0)) AS pendingItems,IF(COUNT(*)!=SUM(IF(bd.status!='OPEN',1,0)),(IF(SUM(IF(bd.status!='OPEN',1,0))=0,MAX(DATE(bd.updated_at)),'Open')),'Closed') AS maxDate
        FROM ` + appSettings.sales_db + `.sale_order_track sot
        LEFT JOIN ` + appSettings.sales_db + `.bom_details bd ON bd.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = soi.processing_unit
        WHERE bd.item_category_id=6 AND so.status!='CLOSE' AND so.so_process_type='MTO' `

            if (req.unitId && req.unitId != 5) {
                query = query + ' and soi.processing_unit = ' + req.unitId;
            }
            if (req.saleOrderId) {
                query = query + ' and sot.sale_order_id = ' + req.saleOrderId;
            }
            if (req.fromDate != undefined) {
                query = query + ' and date(soi.act_edl_date) >= "' + req.fromDate + '" and  date(soi.act_edl_date) <= "' + req.toDate + '"';
            }

            query = query + ` GROUP BY sot.sale_order_id ORDER BY ISNULL(soi.act_edl_date), soi.act_edl_date `
            const data = await manager.query(query);
            if (data.length > 0) {
                const response = new CommonResponse(true, 11208, "Packing Bom retrieved successfully", data);
                return response;
            } else {
                throw new CommonResponse(false, 99998, 'No Record Found');
            }
        } catch (err) {
            return err
        }
    }
    async getProsUintDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT sot.sale_order_id , soi.processing_unit AS procUnit ,uc.unit_name as unitName FROM ` + appSettings.sales_db + `.sale_order_track sot
        LEFT JOIN ` + appSettings.sales_db + `.bom_details bd ON bd.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = soi.processing_unit
      WHERE bd.item_category_id=6 AND so.status!='CLOSE' AND so.so_process_type='MTO'  `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and soi.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY uc.unit_name ORDER BY procUnit `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getSoDropForBomReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT sot.sale_order_id as saleOrderId,soi.po_number AS poNum ,soi.processing_unit FROM ` + appSettings.sales_db + `.sale_order_track sot 
        left join ` + appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = sot.sale_order_id
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = soi.processing_unit
        LEFT JOIN ` + appSettings.sales_db + `.bom_details bd ON bd.sale_order_id = sot.sale_order_id
        WHERE bd.item_category_id=6 AND so.status!='CLOSE' AND so.so_process_type='MTO' AND sot.sale_order_id> 0 and soi.processing_unit > 0` ;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and soi.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY soi.po_number  ORDER BY poNum `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }


    async CycleCheckerEntry(cycleCheckerDTO: CycleCheckerDTO, isUpdate: boolean): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            cycleCheckerDTO.itemCategoryId = 6;
            cycleCheckerDTO.saleOrderId = 0;
            if (!isUpdate) {
                const cycleCheckerEntity = await this.getCycleChecker(cycleCheckerDTO.cycleCheckerId)
                if (cycleCheckerEntity) {
                    throw new CommonResponse(false, 11104, 'Stock already exists');
                }
            } else {
                const cycleCheckerEntity = await this.getCycleChecker(cycleCheckerDTO.cycleCheckerId)
                if (cycleCheckerEntity) {
                    if (cycleCheckerEntity.cycleCheckerId != cycleCheckerDTO.cycleCheckerId) {
                        throw new CommonResponse(false, 11104, 'Stock  already exists');
                    }
                }
            }
            const convertedcycleCheckerEntity: CycleChecker = this.cycleCheckeradapter.convertDtoToEntity(cycleCheckerDTO);

            const savedcycleCheckerEntity: CycleChecker = await manager.getCustomRepository(CycleCheckerRepository).save(convertedcycleCheckerEntity);

            const savedcycleCheckerDTO: CycleCheckerDTO = this.cycleCheckeradapter.convertEntityToDto(savedcycleCheckerEntity);
            manager.completeTransaction();

            if (savedcycleCheckerDTO) {
                const response = new CommonResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'cycle checker date Updated Successfully' : 'stock Created Successfully', savedcycleCheckerDTO);
                return response;
            } else {
                throw new ErrorResponse(1011, 'Quantity already inserted for the selected Item');
            }
        } catch (error) {
            manager.releaseTransaction();
            return error;
        }
    }

    async getCycleChecker(cycleCheckerId: number): Promise<CycleChecker> {
        const response = await this.cycleCheckerRepository.findOne({
            where: { cycleCheckerId: cycleCheckerId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getCycleCheckerData(req:CycleCheckerDateRequest): Promise<CommonResponse> {
        console.log(req,"req serviceee")
        const manager = getManager()
        let query = "SELECT ch.cycle_checker_id as cycleCheckerId,ch.item_id as itemId,ch.unit_id as unitId,ch.item_category_id as itemCategoryId,ch.item_sub_category_id as itemSubCategoryId,ch.master_brand_id as masterBrandId,ch.saleorder_id as saleOrderId,ch.created_at createdAt,ch.created_user as createdUser,ch.updated_at as updatedAt, ch.updated_user as updatedUser,ch.status as status, ch.physical_quantity AS physicalQuantity ,mb.brand_name AS brand, isc.item_sub_category AS itemSubCategory , i.item_name AS itemName, uc.unit_name as unit,ch.location AS locationId,rp.rm_rack_code as rackCode,reason FROM `erpx_dev_procurement`.`cycle_checker` ch LEFT JOIN `erpx_dev_masters`.`master_brands` mb ON mb.master_brand_id = ch.master_brand_id LEFT JOIN `erpx_dev_masters`.item_sub_categories isc ON isc.item_sub_category_id = ch.item_sub_category_id LEFT JOIN `erpx_dev_masters`.`items` i ON i.item_id = ch.item_id LEFT JOIN `erpx_dev_masters`.`unitcodes` uc ON uc.unit_code_id = ch.unit_id LEFT JOIN erpx_dev_masters.rm_rack_position rp ON rp.rm_rack_position_id = ch.location  where ch.cycle_checker_id>=0"

        if (req.fromDate != undefined) {
            query = query + ' and date(ch.created_at) >= "' + req.fromDate + '" and  date(ch.created_at) <= "' + req.toDate + '"';
        }
        query+=` ORDER BY ch.created_at DESC`
        console.log(query,"queryyyyy")
        const data = await manager.query(query);
        if (data) {
            const reso = new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
            const newLogDto = new LogsDto(1, 'view cycle checker', 'Stock', 0, true, reso.internalMessage, '')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return reso
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }

    async getCycleCheckerTableData(): Promise<CommonResponse> {
        const manager = getManager()
        let query = "SELECT ch.cycle_checker_id as cycleCheckerId,ch.item_id as itemId,ch.unit_id as unitId,ch.item_category_id as itemCategoryId,ch.item_sub_category_id as itemSubCategoryId,ch.master_brand_id as masterBrandId,ch.saleorder_id as saleOrderId,ch.created_at createdAt,ch.created_user as createdUser,ch.updated_at as updatedAt, ch.updated_user as updatedUser,ch.status as status, ch.physical_quantity AS physicalQuantity ,mb.brand_name AS brand, isc.item_sub_category AS itemSubCategory , i.item_name AS itemName, uc.unit_name as unit,ch.location as locationId,rp.rm_rack_code AS rackCode FROM `erpx_dev_procurement`.`cycle_checker` ch LEFT JOIN `erpx_dev_masters`.`master_brands` mb ON mb.master_brand_id = ch.master_brand_id LEFT JOIN `erpx_dev_masters`.item_sub_categories isc ON isc.item_sub_category_id = ch.item_sub_category_id LEFT JOIN `erpx_dev_masters`.`items` i ON i.item_id = ch.item_id LEFT JOIN `erpx_dev_masters`.`unitcodes` uc ON uc.unit_code_id = ch.unit_id LEFT JOIN erpx_dev_masters.rm_rack_position rp ON rp.rm_rack_position_id = ch.location ORDER BY ch.created_at DESC"
        const data = await manager.query(query);
        if (data) {

            const result1 = new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
            const newLogDto = new LogsDto(1, 'view Cycle checker table data', 'Stock', 0, true, result1.internalMessage, '')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return result1
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }

    async cycleCheckerApproval(cycleCheckerDTO: CycleCheckerDTO, isUpdate: boolean): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        const dataManager = getManager()
        try {
            await manager.startTransaction();
            const stockEntryDto = new StockDto(undefined, cycleCheckerDTO.unitId, cycleCheckerDTO.physicalQuantity, cycleCheckerDTO.itemCategoryId, undefined, cycleCheckerDTO.itemId, undefined, cycleCheckerDTO.saleOrderId, undefined, undefined, undefined, undefined, undefined, undefined, cycleCheckerDTO.locationId, undefined, cycleCheckerDTO.createdUser, cycleCheckerDTO.updatedUser, cycleCheckerDTO.itemSubCategoryId, undefined, cycleCheckerDTO.masterBrandId, undefined);
            console.log('cycleCheckerDTO', cycleCheckerDTO)
            const savedstockEntityRes: CommonResponse = await this.stockEntry(stockEntryDto, true,);

            const query = `SELECT location_id as locationId , SUM(physical_quantity + intransit_quantity) as physicalQty  FROM ` + appSettings.procure_db + `.stock WHERE location_id = ` + cycleCheckerDTO.locationId;
            const qtyData = await dataManager.query(query)
            console.log('------111------', qtyData)
            if (qtyData[0]?.physicalQty == 0) {
                console.log('------22222------', qtyData[0].physicalQuantity)
                const rackPositionIdDto = new RmRackPositionIdReq()
                rackPositionIdDto.rmRackPositionId = cycleCheckerDTO.locationId;
                console.log('--------333333-------', rackPositionIdDto)
                await this.rmRackPositionService.updateLocationData(rackPositionIdDto)
            }
            await manager.completeTransaction();

            if (savedstockEntityRes.status) {
                cycleCheckerDTO.status = CycleCheckerEnum.APPROVED;
                await this.cycleCheckerRepository.update({ cycleCheckerId: cycleCheckerDTO.cycleCheckerId }, { status: cycleCheckerDTO.status });
                const response = new CommonResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'cycle checker date Updated Successfully' : 'stock Created Successfully', savedstockEntityRes);
                return response;
            } else {
                throw new ErrorResponse(1011, 'Quantity already inserted for the selected Item');
            }
        } catch (error) {
            manager.releaseTransaction();
            return error;
        }
    }

    async updateStockToBulk(req: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            const transmanager = new GenericTransactionManager();
            const updateflag = new Set<boolean>()
            await transmanager.startTransaction()
            const stockExist = await this.stockRepository.find({ where: { saleOrderId: req.saleOrderId, physicalQuantity: MoreThan(0) } })
            if (stockExist && stockExist.length > 0) {

                for (const item of stockExist) {
                    // update current Items physical quantity to zero 
                    const updateCurrentItemData = await transmanager.getCustomRepository(StockRepository).update({ saleOrderId: item.saleOrderId, unitId: item.unitId, itemId: item.itemId, locationId: item.locationId }, { physicalQuantity: 0 })
                    console.log(updateCurrentItemData, 'updateCurrentItemData')
                    if (!updateCurrentItemData.affected) {
                        updateflag.add(false);
                        break;
                    }
                    // check if the item is there in stock table with sale order id 0 ,if present update the qty else create the item
                    const findItemInBulk = await transmanager.getCustomRepository(StockRepository).findOne({ where: { saleOrderId: 0, itemId: item.itemId, unitId: item.unitId, locationId: item.locationId } })
                    console.log(findItemInBulk, 'findItemInBulk')
                    if (findItemInBulk) {
                        const updateBulkQuantity = await transmanager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: item.itemId, unitId: item.unitId, locationId: item.locationId }, { physicalQuantity: () => `physical_quantity+${item.physicalQuantity}` })
                        console.log(updateBulkQuantity, 'updateBulkQuantity')
                        if (!updateBulkQuantity.affected) {
                            updateflag.add(false);
                            break;
                        }
                    } else {
                        const newItem = new Stock()
                        newItem.itemId = item.itemId;
                        newItem.itemCategoryId = 6;
                        newItem.itemSubCategoryId = item.itemSubCategoryId;
                        newItem.physicalQuantity = item.physicalQuantity;
                        newItem.unitId = item.unitId;
                        newItem.openingBalance = 0.000;
                        newItem.unitPrice = 0.000;
                        newItem.minimumStock = 0.000;
                        newItem.locationId = item.locationId;
                        newItem.saleOrderId = 0;
                        const createItemInBulk = await transmanager.getCustomRepository(StockRepository).save(newItem)
                        console.log(createItemInBulk, 'createItemInBulk')
                        if (!createItemInBulk) {
                            updateflag.add(false)
                            break;
                        }
                    }

                }
                if (!updateflag.has(false)) {
                    await transmanager.completeTransaction()
                    return new CommonResponse(true, 1111, 'Stock updated sucessfully')
                } else {
                    await transmanager.releaseTransaction()
                    return new CommonResponse(false, 1111, 'Some thing went wrong while updating data')

                }
            } else {
                await transmanager.releaseTransaction()
                return new CommonResponse(true, 11111, 'stock not exist with the sale order id')
            }
        }
        catch (error) {
            throw error
        }
    }
    async getPackingMaterialInfo(req: ItemCodeRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            console.log(req);
            let query = "Select sale_order_id AS saleOrderId, sale_order_item_id AS saleOrderItemId, SUM(consumed_quantity) AS consumedQuantity,prepared_stock_id AS preparedStockId from " + appSettings.procure_db + ".prepared_stock ps where item_barcode = '" + req.itemCode + "' and unit_id = " + req.unitId + ' and consumed_quantity > 0 limit 1';
            let result = await manager.query(query);
            if (result[0].saleOrderId > 0) {
                return new CommonResponse(true, 1001, "Details retreived successfully", result);
            }
            else {
                return new CommonResponse(false, 1010, "no barcode found. ");
            }
        }
        catch (error) {
            throw error
        }
    }

    async createMaterilaPreperation(req: MaterialPreperationRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            console.log(req)
            await manager.startTransaction()
            const preaparedData = await this.materialPreperationRepo.findOne({
                select: ['preparedStockId'],
                order: { preparedStockId: "DESC" }
            })
            let maxId
            if (preaparedData) {
                maxId = Number(preaparedData.preparedStockId) + 1;
            } else {
                maxId = 1
            }
            var refNo = maxId + "";
            while (refNo.length < 4) refNo = "0" + refNo;
            const productBarcodeData = await this.saleService.getProductBarcode(new ProductBarcodeRequest(req.saleOrderId, req.saleOrderItemId, req.itemId));
            if (!(productBarcodeData.status)) {
                await manager.releaseTransaction()
                return new CommonResponse(false, 11101, 'barcode not exist', undefined);
            }
            const productBarcode = productBarcodeData.data
            const barcomboExist = await this.materialPreperationRepo.findOne({ where: { itemId: req.itemId, saleOrderId: req.saleOrderId, saleOrderItemId: req.saleOrderItemId } })
            let barcode
            let productName
            if (barcomboExist) {
                barcode = barcomboExist.barcode
            } else {
                // barcode = 'Barcode/'+refNo
                barcode = productBarcode
            }
            if (barcomboExist) {
                productName = barcomboExist.productName
            } else {
                productName = req.soItemName + '/' + req.itemName
            }
            const preparedStockEntity: PreapredStock = this.materialPreperationAdapter.convertDtoToEntity(req, false, req.soItemBarcode, req.soItemName + '/' + req.itemName);
            console.log(preparedStockEntity);
            const savedPreparedStockEntity: PreapredStock = await manager.getCustomRepository(MaterialPreperationRepository).save(preparedStockEntity);
            // const savedProductDto: MaterialPreperationRequest = this.materialPreperationAdapter.convertEntityToDto(savedPreparedStockEntity);

            if (savedPreparedStockEntity) {
                //stock updation
                const stockData = await this.stockRepository.find({ where: { stockId: req.stockId } })
                if (stockData) {
                    const stockUpdate = await manager.getCustomRepository(StockRepository).update({ stockId: req.stockId }, {
                        physicalQuantity: () => `physical_quantity-${req.preparedQuantity}`
                        , preparedQuantity: () => `prepared_quantity+${req.preparedQuantity}`
                    })
                    if (stockUpdate.affected) {
                        // const trimItems = await this.saleService.getTrimsItemsForSo(new saleOrder(req.saleOrderId))
                        // const trimItemIds = []
                        // console.log(trimItems, 'trimItemsquery')
                        // if (trimItems.status) {
                        //     for (const trimItem of trimItems.data) {
                        //         trimItemIds.push(trimItem.itemId)
                        //     }
                        //     console.log(trimItemIds, 'trimItemIdsss')
                        //     const trimsData = await this.trimsmappingService.getTrimsData(new TrimsMappingRequset(req.brandId, req.packStyleId, req.variantId, req.endCustomerId, 'Preperation', trimItemIds, req.subCategoryId))
                        //     console.log(trimsData)
                        //     let Svaeflag = true
                        //     for (const trimsDataItem of trimsData.data) {

                        //         console.log('insert')
                        //         const dtorIssueObj = new StoreIssuesRequestDto(null, new Date(), null, null, new Date(), req.saleOrderId, req.saleOrderItemId, req.unitId, null, StoreConsumptionStatus.Open, GlobalStatus.NO, trimsDataItem.itemId, req.preparedQuantity * trimsDataItem.numberOfTrims, 0, req.soItemBarcode, StockStatus.SaleOrder, TransactionType.rm, req.createdUser, null, null, null)
                        //         const storeConsumptionObj = new StoreConsumption();
                        //         storeConsumptionObj.indentDate = new Date()
                        //         storeConsumptionObj.consumedDate = new Date()
                        //         storeConsumptionObj.saleOrderId = req.saleOrderId
                        //         storeConsumptionObj.saleOrderItemId = req.saleOrderItemId
                        //         storeConsumptionObj.unitId = req.unitId
                        //         storeConsumptionObj.status = StoreConsumptionStatus.Open
                        //         storeConsumptionObj.isPreparedMaterial = GlobalStatus.NO
                        //         storeConsumptionObj.itemId = trimsDataItem.itemId
                        //         storeConsumptionObj.issuedQuantity = Number(req.preparedQuantity * trimsDataItem.numberOfTrims)
                        //         storeConsumptionObj.returnedQuantity = 0
                        //         storeConsumptionObj.barcode = req.soItemBarcode
                        //         storeConsumptionObj.stockType = StockStatus.SaleOrder
                        //         storeConsumptionObj.transactionType = TransactionType.rm
                        //         storeConsumptionObj.createdUser = req.createdUser
                        //         const saveIssue = await manager.getCustomRepository(StoreConsumptionRepository).save(storeConsumptionObj);

                        //         // const saveIssue = await this.storeConsumptionService.createStoreIssues(dtorIssueObj);

                        //         console.log('trimissued', saveIssue)
                        //         console.log('dtorIssueObj', dtorIssueObj)
                        //         if (!saveIssue) {
                        //             Svaeflag = false
                        //             break
                        //         } else {
                        //             const consumedTrimsQty = Number(req.preparedQuantity * trimsDataItem.numberOfTrims)
                        //             //stock update
                        //             const updateStockTrims = await this.updateTrimsStock(trimsDataItem.itemId, req.saleOrderId, consumedTrimsQty, req.unitId, manager)
                        //             if (updateStockTrims) {
                        //                 Svaeflag = true
                        //             } else {
                        //                 Svaeflag = false
                        //                 break
                        //             }
                        //         }
                        //     }
                        //     // if(trimsData.status){
                        //     // }
                        //     if (Svaeflag) {
                        //         await manager.completeTransaction()
                        //         return new CommonResponse(true, 11101, 'Material Prepeartion Created Successfully', undefined);
                        //     } else {
                        //         await manager.releaseTransaction()
                        //         return new CommonResponse(false, 11101, 'Something went wrong in trims consumption update/No stock for Trims', undefined);
                        //     }
                        // } else {
                        //     await manager.completeTransaction()
                        //     return new CommonResponse(true, 11101, 'Material Prepeartion Created Successfully', undefined);
                        // }
                        //trims consumption commented for temerory
                        await manager.completeTransaction()
                        return new CommonResponse(true, 11101, 'Material Prepeartion Created Successfully', undefined);
                    } else {
                        await manager.releaseTransaction()
                        return new CommonResponse(false, 11101, 'Something went wrong in stock updation', undefined);

                    }
                } else {
                    await manager.releaseTransaction()
                    return new CommonResponse(false, 11101, 'Stock not found to update', undefined);
                }

            } else {
                await manager.releaseTransaction()
                return new CommonResponse(false, 11106, 'Something Went Wrong in Material Prepeartion creation');
            }
        }
        catch (error) {
            await manager.releaseTransaction()
            return new CommonResponse(false, 11106, error);
        }
    }

    async getPreparedMaterialForItem(req: PreparedStockRequest): Promise<CommonResponse> {
        const manager = getManager()
        console.log('reqppp')
        console.log(req)
        const preparedMaterialStockQry = "SELECT sum(prepared_quantity) as preparedQty from prepared_stock where item_barcode = '" + req.itemBarcode + "' and unit_id = " + req.unitId;
        const preparedQtyData = await manager.query(preparedMaterialStockQry)
        console.log(preparedQtyData)
        if (preparedQtyData.length > 0) {
            return new CommonResponse(true, 8888, 'qty retrived', preparedQtyData[0].preparedQty)
        } else {
            return new CommonResponse(true, 8888, 'qty retrived', 0)
        }
    }

    async getMaterialPreparationData(req: MaterialGridRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT ps.item_barcode AS itemBarCode , ps.prepared_quantity AS preQty , ps.consumed_quantity AS consQty, ps.stock_in_quantity AS stockInQty,pm.packing_method_name as packMethodName, sc.variant_code as variantCode,
        ps.status AS status ,  i.item_name AS item , uc.unit_name AS unit, si.po_number as saleOrderNo,
        CONCAT(pm.packing_method_name,'-',sc.variant_code ) AS soItem , ps.unit_id as unitId,ps.created_at as createdDate,ps.barcode as barCode FROM ` + appSettings.procure_db + `.prepared_stock ps 
        LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = ps.item_id 
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = ps.unit_id 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = ps.sale_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_items soi ON soi.sale_order_item_id = ps.sale_order_item_id 
        LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = soi.pack_style_id LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id = soi.varient_id WHERE ps.sale_order_id > 0 `
        if (req.unitId && req.unitId != 5) {
            query = query + ' and ps.unit_id = ' + req.unitId;
        }
        if (req.saleOrderId) {
            query = query + ' and si.sale_order_id = ' + req.saleOrderId;
        }
        if (req.itemId) {
            query = query + ' and i.item_id = ' + req.itemId;
        }
        if (req.status && req.status.length) {
            let statusFilter = req.status.map((it) => { return `'${it}'` })
            query = query + ' and ps.status IN (' + statusFilter + ')';
        }
        const data = await manager.query(query)
        if (data.length > 0) {
            const response = new CommonResponse(true, 8888, 'qty retrived', data)
            const newLogDto = new LogsDto(1, 'view material preparation', 'Stock', 0, true, response.internalMessage, '')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
        } else {
            return new CommonResponse(true, 8888, 'No data found')
        }
    }
    async getStatusDropDown(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT  ps.status as status , ps.unit_id as unitId FROM ` + appSettings.procure_db + `.prepared_stock ps WHERE ps.prepared_stock_id > 0 `
        if (req.unitId && req.unitId != 5) {
            query = query + ' and ps.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY ps.status `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1421, 'No data')
        }
    }
    async getSoDropDown(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT si.sale_order_id as saleOrderId , si.po_number AS soNumber ,  ps.unit_id FROM ` + appSettings.procure_db + `.prepared_stock ps
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = ps.sale_order_id
        WHERE si.sale_order_id> 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and ps.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY si.sale_order_id  ORDER BY soNumber `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1421, 'No data')
        }
    }
    async getItemDropDown(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT i.item_id AS itemId , i.item_name AS item , ps.unit_id FROM ` + appSettings.procure_db + `.prepared_stock ps
        LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = ps.item_id
        WHERE i.item_id> 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and ps.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY i.item_id `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1421, 'No data')
        }
    }
    async getPreparedAvailableStockQty(stockItemRequest: StockIdReq): Promise<AvailableStockQtyResponseModel> {
        try {
            const manager = getManager()
            const query = "SELECT sum(prepared_quantity) as preparedQuantity,s.stock_id as stockId from " + appSettings.procure_db + ".stock s where s.stock_id = " + stockItemRequest.stockId + " and s.unit_id = " + stockItemRequest.unitId
            const availStock = await manager.query(query)
            console.log(availStock, 'availStock')
            if (availStock) {
                const data = new AvailStockDto(Number(availStock[0].preparedQuantity), availStock[0].stockId, undefined);
                console.log(data);

                const response: AvailableStockQtyResponseModel = new AvailableStockQtyResponseModel(true, 10114, 'Available Stock Quantity retrived successfully', data);
                return response;
            } else {
                throw new AvailableStockQtyResponseModel(false, 9999, 'Stock not available');
            }
        } catch (err) {
            return err
        }
    }


    async getExcessInventoryReport(req: UnitIdRequest): Promise<CommonResponse> {
        const manager = getManager()

        let stockQuery = `SELECT s.item_id as itemId,s.unit_id as unitId,uc.unit_name as unitName,SUM(s.physical_quantity) as physicalQty,s.item_id as itemId,i.item_name as itemName FROM ${appSettings.procure_db}.stock s
        LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = s.item_id
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = s.unit_id
        WHERE s.saleorder_id = 0 AND physical_quantity > 0`
        if (req.unitId && req.unitId != 5) {
            stockQuery = stockQuery + ` AND unit_id = ${req.unitId}`
        }
        stockQuery = stockQuery + ` GROUP BY s.item_id`
        const stockData = await manager.query(stockQuery)
        const reportData = []
        for (const e of stockData) {
            let bomQuery = `SELECT SUM(required_qty) as requiredQty,b.item_id FROM ${appSettings.sales_db}.bom_details b
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id = b.sale_order_id
            WHERE b.item_id = ${e.itemId} AND required_qty > 0`
            if (req.unitId && req.unitId != 5) {
                bomQuery = bomQuery + ` AND processing_unit = ${req.unitId}`
            }
            bomQuery = bomQuery + ` GROUP BY item_id`

            const bom = await manager.query(bomQuery)
            if (bom && bom.length) {
                e.requiredQty = bom[0].requiredQty
                e.excessQty = Number(e.physicalQty) - Number(bom[0].requiredQty)
                if (e.excessQty > 0) {
                    reportData.push(e)
                }
            }
        }

        // const data = await manager.query(query)
        if (stockData.length > 0) {
            return new CommonResponse(true, 8888, 'qty retrived', reportData)
        } else {
            return new CommonResponse(true, 8888, 'No data found')
        }
    }

    async getPreparedStockByBarcode(req: BarcodeReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT product_name as productName,barcode,ps.sale_order_id as saleOrderId,sale_order_item_id as saleOrderItemId,ps.item_id as itemId,SUM(prepared_quantity) AS preparedQty,SUM(consumed_quantity) as consumedQty,soi.po_number as poNumber,i.item_name as itemName FROM ` + appSettings.procure_db + `.prepared_stock ps 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id = ps.sale_order_id
        LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = ps.item_id 
        WHERE ps.barcode = '${req.barcode}' and unit_id = ${req.unitId} and ps.item_id = ${req.itemId} GROUP BY barcode,ps.sale_order_id,sale_order_item_id,ps.item_id`
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 8888, 'data retrived', data)
        } else {
            return new CommonResponse(false, 8888, 'no data found with the barcode')
        }
    }

    async getDummyItems(req: SaleOrderIdRequest): Promise<ItemsDetailsResponseModel> {
        try {
            const manager = getManager();
            let query = `select s.item_id as itemId,i.item_name as itemName from ` + appSettings.procure_db + `.stock s left join ` + appSettings.masters_db + `.items i on i.item_id = s.item_id where s.saleorder_id = ` + req.saleOrderId + `  and s.unit_id = ` + req.plantId + ` and i.is_preperation_required = '` + GlobalStatus.NO + `' group by s.item_id`
            const data = await manager.query(query)
            if (data) {
                return new ItemsDetailsResponseModel(true, 1141, 'Data retrieve successfully', data)
            } else {
                return new ItemsDetailsResponseModel(false, 1141, 'No data')
            }

        } catch (error) {
            return error
        }
    }

    async getPreparedProductsData(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager();
        const productsDataQry = `select distinct(product_name) as productName,barcode from ` + appSettings.procure_db + `.prepared_stock ps where ps.unit_id = ` + req.unitId
        const data = await manager.query(productsDataQry)
        if (data.length > 0) {
            return new CommonResponse(true, 1141, 'Data retrieve successfully', data)
        } else {
            return new CommonResponse(false, 1141, 'No data')
        }

    }

    async getReasonsForProdConversion(): Promise<CommonResponse> {
        const manager = getManager();
        const reasonQuery = ` SELECT reasons_name as reason from ` + appSettings.masters_db + `.reasons`
        const data = await manager.query(reasonQuery)
        if (data.length > 0) {
            return new CommonResponse(true, 1141, 'Data retrieve successfully', data)
        } else {
            return new CommonResponse(false, 1141, 'No data')
        }
    }
    async getStockQtyForCycleChecker(req: ItemIdReq): Promise<CommonResponse> {
        const manager = getManager()
        const query = `SELECT physical_quantity as physicalQty,item_id as itemId , unit_id as unitId , location_id as locationId,saleorder_id FROM ` + appSettings.procure_db + `.stock WHERE item_id = ` + req.itemId + ` AND unit_id = ` + req.unitId + ` AND location_id = ` + req.locationId + ` AND saleorder_id = 0 `;
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 8888, 'qty retrived', data)
        } else {
            return new CommonResponse(true, 8888, 'No Quantity For Selected Item', 0)
        }
    }

    async getReasonsForCycleChecker(): Promise<CommonResponse> {
        const manager = getManager()
        const query = `SELECT reasons_name as reason,reasons_id as reasonId FROM ` + appSettings.masters_db + `.reasons `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 8888, 'reason retrived', data)
        } else {
            return new CommonResponse(true, 8888, 'something went wrong', 0)
        }
    }

    async getSOAndSoitemCombData(req?: ItemIDRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT DISTINCT(soi.sale_order_item_id) as saleOrderItemId,soi.barcode,soi.sale_order_id as saleOrderId,soinv.po_number as poNumber,mb.brand_name,soi.master_brand_id as masterBrandId,soi.varient_id as variantId,soinv.end_customer_id as endCustomerId,soi.pack_style_id as packStyleId,
            pm.packing_method_name,sk.variant_code,CONCAT(po_number,'-',brand_name,'/',variant_code,'/',packing_method_name) AS productDesc 
            FROM `+ appSettings.procure_db + `.stock st
            LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id = st.saleorder_id
            LEFT JOIN `+ appSettings.sales_db + `.sale_order_items soi ON soi.sale_order_id = st.saleorder_id
            LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soinv ON soinv.sale_order_id = st.saleorder_id
            LEFT JOIN `+ appSettings.masters_db + `.master_brands mb ON mb.master_brand_id = soi.master_brand_id
            LEFT JOIN `+ appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = soi.pack_style_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = soi.varient_id where st.stock_id > 0 and st.saleorder_id > 0`;

            if (req.unitId) {
                query += `  AND st.unit_id=` + req.unitId;
            }
            // query += `  group by s.saleorder_id order by s.saleorder_id`;

            const saleOrders = await manager.query(query);
            if (saleOrders.length > 0) {
                return new CommonResponse(true, 1111, 'Sale Orders Retrieved Successfully', saleOrders)
            } else {
                return new CommonResponse(false, 9999, 'No saleorders with this item')

            }
        } catch (error) {
            return error
        }
    }
    async getSOAndSoitemData(req?: ItemIDRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT DISTINCT(st.sale_order_item_id) as saleOrderItemId,st.barcode,st.sale_order_id as saleOrderId,soinv.po_number as poNumber,mb.brand_name,st.master_brand_id as masterBrandId,st.varient_id as variantId,soinv.end_customer_id as endCustomerId,st.pack_style_id as packStyleId,
            pm.packing_method_name,sk.variant_code,CONCAT(po_number,'-',brand_name,'/',variant_code,'/',packing_method_name) AS productDesc 
            FROM `+ appSettings.sales_db + `.sale_order_items st
            LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id = st.sale_order_id
            LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soinv ON soinv.sale_order_id = st.sale_order_id
            LEFT JOIN `+ appSettings.masters_db + `.master_brands mb ON mb.master_brand_id = st.master_brand_id
            LEFT JOIN `+ appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = st.pack_style_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = st.varient_id where st.sale_order_id > 0 and st.sale_order_item_id =` + req.saleOrderItemId;

            const saleOrders = await manager.query(query);
            if (saleOrders.length > 0) {
                return new CommonResponse(true, 1111, 'Sale Orders Retrieved Successfully', saleOrders)
            } else {
                return new CommonResponse(false, 9999, 'No saleorders with this item')

            }
        } catch (error) {
            return error
        }
    }
    async getLocationsForCycleChecker(req: BrandReqForLocation): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT s.location_id as locationId,rp.rm_rack_code as rackPosition,rp.brand_id FROM ` + appSettings.procure_db + `.stock s 
        LEFT JOIN `+ appSettings.masters_db + `.rm_rack_position rp ON rp.rm_rack_position_id = s.location_id 
        WHERE s.stock_id > 0 AND rp.brand_id = ` + req.brandId
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY s.location_id `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 8888, 'rack position retrived', data)
        } else {
            return new CommonResponse(true, 8888, 'No Racks Available', 0)
        }
    }
    async createLocationMappedStock(req: GRNLocationMappingRequest): Promise<CommonResponse> {
        console.log('request', req)
        const manager = new GenericTransactionManager();
        try {
            let bulkStockId = 0
            let itemcategoryId
            let grnItemsReq = new GrnItemsInfo(req.grnId, req.itemCategoryId, req.itemId, req.sizeId, 0, req.receivedQty, 0, req.unitPrice, 0, 0, 0, 0, 0, req.saleOrderId, req.createdUser, '', req.itemSubCategoryId, null)
            await manager.startTransaction();
            // if(req.saleOrderId > 0){

            //     let isManuallyAddedItem
            //     const bomData = await this.saleService.getBomDataById(new SOBomRequest(req.saleOrderId,undefined,req.itemId,'',''));
            //     console.log(bomData)
            //     if(bomData.data.status){
            //       const packCat = bomData.data.data.packingCategory;
            //       if(packCat != 'Added In PO'){
            //         const updatePackingBOMGRN = await this.saleService.updatePackingBOMGRNData(new BomUpdateRequest(req.itemId,req.saleOrderId,req.physicalQuantity,undefined));
            //         if(!updatePackingBOMGRN.status){
            //             await manager.releaseTransaction()
            //             return new CommonResponse(false,1111, 'Something went wrong in packing BOM log  updation')
            //         }
            //       }
            //     }else{
            //       await manager.releaseTransaction()
            //         return new CommonResponse(false,1111, 'Something went wrong in getting BOM')
            //     }
            //   }
            let stockData
            let toBeMovedBulkQty
            let BulkstockData
            let existingStockId
            let existingStockQty
            let toBeMoved = false
            let soStatus = SaleOrderStatusEnum.OPEN;
            let stockAcceptedQty
            let isTotalMoved = false
            let isOnlyInsert = false
            let isInsertAndInsert = false
            let stockBulkAcceptedQty

            //check weathre saleorder cancelled or not
            const soStatusInfo = await this.saleService.getSoStatusBySoId({ saleOrderId: req.saleOrderId });
            const bomStatusInfo = await this.saleService.getBomDataById({ saleOrderId: req.saleOrderId, plantId: null, itemId: req.itemId })
            // console.log('bomStatusInfo');
            // console.log(bomStatusInfo);
            if (bomStatusInfo.data.status) {
                // console.log('one')
                // const existedstockData = await this.stockRepository.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId, unitId: req.grnUnitId } })
                const existedstockData = await manager.getCustomRepository(StockRepository)
                .createQueryBuilder("stock")
                .select("SUM(stock.physicalQuantity)", "physicalQuantity")
                .where("stock.saleOrderId = :saleOrderId", { saleOrderId: req.saleOrderId })
                .andWhere("stock.itemId = :itemId", { itemId: req.itemId })
                .andWhere("stock.unitId = :unitId", { unitId: req.grnUnitId })
                .getRawOne();


                // console.log('existedstockData')
                // console.log(existedstockData)
                // console.log(bomStatusInfo.data.data.isRequired)

                // if(existedstockData){
                if (existedstockData && bomStatusInfo.data.data.isRequired == GlobalStatus.NO || (bomStatusInfo.data.data.isRequired == GlobalStatus.YES && bomStatusInfo.data.data.isQtyRevised == GlobalStatus.YES && existedstockData && (Number(bomStatusInfo.data.data.quantity) < (Number(existedstockData.physicalQuantity) + Number(req.physicalQuantity))))) {
                    console.log('two')
                    toBeMovedBulkQty = (Number(req.physicalQuantity)) - (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
                    toBeMoved = true
                    if (bomStatusInfo.data.data.quantity <= Number(existedstockData.physicalQuantity)) {
                        isOnlyInsert = true
                        stockAcceptedQty = req.physicalQuantity
                    }
                    if (bomStatusInfo.data.data.quantity > Number(existedstockData.physicalQuantity) && (Number(bomStatusInfo.data.data.quantity) < (Number(existedstockData.physicalQuantity) + Number(req.physicalQuantity)))) {
                        isInsertAndInsert = true
                        stockData = await this.stockRepository.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId, unitId: req.grnUnitId, locationId: (req.locationId) } })
                        stockAcceptedQty = (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
                        stockBulkAcceptedQty = Number(req.physicalQuantity) - (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
                    }


                } else {
                    console.log('three')

                    if (soStatusInfo.data.status) {
                        console.log('four')

                        stockData = await this.stockRepository.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: req.itemId, unitId: req.grnUnitId, locationId: (req.locationId) } })
                        soStatus = SaleOrderStatusEnum.CANCELLED;
                        stockAcceptedQty = req.physicalQuantity
                    } else {
                        console.log('five')

                        stockData = await this.stockRepository.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId, unitId: req.grnUnitId, locationId: (req.locationId) } })
                        stockAcceptedQty = req.physicalQuantity
                    }
                }
                // }
               

            } else {
                console.log('five')

                stockData = await this.stockRepository.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId, unitId: req.grnUnitId, locationId: (req.locationId) } })
                stockAcceptedQty = req.physicalQuantity
            }
            if (toBeMoved) {
                console.log('six')

                stockData = await this.stockRepository.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: req.itemId, unitId: req.grnUnitId, locationId: (req.locationId) } })
                if (isInsertAndInsert) {
                    stockData = await this.stockRepository.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId, unitId: req.grnUnitId, locationId: (req.locationId) } })
                    const bulkExistingData = await this.stockRepository.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: req.itemId, unitId: req.grnUnitId, locationId: (req.locationId) } })
                    if (bulkExistingData) {
                        bulkStockId = bulkExistingData.stockId;
                        const stockUpdate = await manager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: req.itemId }, { physicalQuantity: () => `physical_quantity+${toBeMovedBulkQty}` })
                        if (!stockUpdate.affected) {
                            await manager.releaseTransaction()
                            return new CommonResponse(false, 1111, 'Something went wrong in stock updation')
                        }
                    } else {
                        let newbulkSave = true
                        // const grnItemsReq = new GrnItemsInfo(req.grnId,req.itemCategoryId,req.itemId,req.sizeId,0,req.physicalQuantity,0,req.unitPrice,0,0,0,0,0,req.createdUser,'')
                        const convertedBulkStockEntity: Stock = this.stockAdapter.convertDtoToEntity(grnItemsReq, existingStockId, existingStockQty, req.locationId, req.grnUnitId, soStatus, stockBulkAcceptedQty, isInsertAndInsert, isOnlyInsert,newbulkSave);
                        const savedBulkStockEntity: Stock = await manager.getRepository(Stock).save(convertedBulkStockEntity);
                        if (savedBulkStockEntity) {
                            bulkStockId = savedBulkStockEntity.stockId;
                        }
                        if (!savedBulkStockEntity) {
                            await manager.releaseTransaction()
                            return new CommonResponse(false, 111, 'something went wrong in bulk stock insertion')
                        }
                    }
                }
            }


            //check weather the request Item is new or existed against Sale order

            if (stockData) {
                existingStockId = stockData.stockId;
                existingStockQty = stockData.physicalQuantity;

            }
            itemcategoryId = req.itemCategoryId;

            //saved grn items addition into stock 
            // if(stockCheckCount > 0){
            // const stockUpdate = await this.stockRepository.update({purchaseOrderId:poId,itemName:itemId},{ receivedQuantity: updatedRecQty} )
            // }else{
            console.log('hereee')
            const convertedStockEntity: Stock = this.stockAdapter.convertDtoToEntity(grnItemsReq, existingStockId, existingStockQty, req.locationId, req.grnUnitId, soStatus, stockAcceptedQty, isInsertAndInsert, isOnlyInsert);
            console.log(convertedStockEntity, 'convertedStockEntity')
            // }

            const savedStockEntity: Stock = await manager.getRepository(Stock).save(convertedStockEntity);
            console.log(savedStockEntity, 'savedStockEntity')

            const savedStockDto: any = this.stockAdapter.convertEntityToDto(savedStockEntity);
            if (!savedStockEntity) {
                await manager.releaseTransaction()
                return new CommonResponse(false, 111, 'something went wrong in stock saving')
            }
            const stockLogObj = new StockLog()
            stockLogObj.grnId = req.grnId
            stockLogObj.grnItemId = req.grnItemId
            stockLogObj.itemId = req.itemId
            stockLogObj.stockId = savedStockDto.stockId
            stockLogObj.locationId = req.locationId
            stockLogObj.saleOrderId = req.saleOrderId
            stockLogObj.unitId = req.grnUnitId
            stockLogObj.createdUser = req.createdUser
            stockLogObj.quantity = req.physicalQuantity
            const savedStockLogEntity: StockLog = await manager.getRepository(StockLog).save(stockLogObj);
            if (!savedStockLogEntity) {
                await manager.releaseTransaction()
                return new CommonResponse(false, 111, 'something went wrong in stock Log saving')
            }


            //mapping GRn with stock
            const itemStockMapUpdate = await manager.getRepository(GrnItems).update({ grnItemId: req.grnItemId }, { stockId: savedStockDto.stockId, bulkStockId: bulkStockId })
            if (!itemStockMapUpdate) {
                await manager.releaseTransaction()
                return new CommonResponse(false, 111, 'something went wrong in stock and Grn mapping')
            }


            //   //Received GRN Qty updation against PO
            //   const recQty = await manager.getRepository(PoItems).findOne({ select: ['receivedQuantity', 'itemQuantity'], where: { purchaseOrderId: req.poId, itemCategory: req.itemCategoryId, itemName: req.itemId, saleOrderId: req.saleOrderId } })
            //   const poItemsUpdate = await this.poItemRepo.updateReceivedQty(recQty.receivedQuantity, req.physicalQuantity, req.itemId, req.poId, req.saleOrderId, req.itemCategoryId, manager)


            //   if (req.saleOrderId) {
            //     const bulkstockDetails = await this.getInventoryStockQty({
            //       saleOrderId: undefined, itemCategoryId: req.itemCategoryId, itemId: req.itemId
            //     }
            //     );
            //     let existingQty = 0;
            //     if (bulkstockDetails.status) {
            //       if (bulkstockDetails.data.physicalQuantity > 0) {
            //         existingQty = bulkstockDetails.data.physicalQuantity;
            //       }
            //     }
            //     //received qty updation in BOM against saleorder and item
            //     const bomItemUpdate: boolean = await this.saleService.updateBomQty(new BomUpdateRequest(req.itemId, req.saleOrderId, req.physicalQuantity, existingQty))

            //     if (!bomItemUpdate) {
            //       await manager.releaseTransaction()
            //         return new CommonResponse(false,11106, 'Something went wrong in updation of BOM Received Quantity');

            //     }

            //     //updation of 
            //     const soTrackUpdate = await this.saleService.updateSoTrackPmStatus(new SoRequest(req.saleOrderId, itemcategoryId))

            //     const latestUpdatedQty = Number(recQty.receivedQuantity) + Number(req.physicalQuantity);
            //   }
            //   //Need clarity
            //   const poItemsdata = await manager.getRepository(PoItems).find({ select: ['receivedQuantity', 'itemQuantity'], where: { purchaseOrderId: req.poId, isActive: true } })
            //   const qtyFlagSet = new Set<boolean>();

            //   for (const poItem of poItemsdata) {

            //     if (Number(poItem.receivedQuantity) >= Number(poItem.itemQuantity)) {
            //       qtyFlagSet.add(true)
            //     } else {
            //       qtyFlagSet.add(false)
            //     }
            //   }
            //   let statusVal = StatusEnum.IN_PROGRESS;
            //   if (!(qtyFlagSet.has(false))) {
            //     statusVal = StatusEnum.CLOSED;
            //   }
            // //   const existingPodata =  await manager.getCustomRepository(PoRepository).findOne({purchaseOrderId:req.poId})
            // //   let maxGrnDate = grnDto.grnDate
            // //   if(existingPodata){
            // //     if(existingPodata.maxGrnDate == null || existingPodata.maxGrnDate < grnDto.grnDate){
            // //       maxGrnDate = grnDto.grnDate
            // //     }
            // //   }
            //   const poStatusUpdate = await manager.getCustomRepository(PoRepository).update({ purchaseOrderId: req.poId }, { status: statusVal
            //     // ,maxGrnDate:maxGrnDate
            // });
            const locationStatusUpdate = await this.rmRackCodeService.updateRmLocationStatus(new RMrackStatusRequest(req.locationId, req.locationStatus, req.grnUnitId, req.itemSubCategoryId, req.brandId))
            if (!(locationStatusUpdate.status)) {
                await manager.releaseTransaction()
                return new CommonResponse(false, 11106, 'Something went wrong in status updation');
            }
            //   //inventory logs saving
            //   const inventorylogdto = new InventoryLogsDto(req.locationId,req.locationId,req.saleOrderId,req.saleOrderId,stockData.stockId,req.physicalQuantity,req.physicalQuantity)
            //   console.log(inventorylogdto);
            //   await this.createinventiryLogs(inventorylogdto)
            await manager.completeTransaction();
            const data = new CommonResponse(true, 11106, 'location mapped successfully');
            const newLogDto = new LogsDto(1, 'created location mapping', 'Stock', req.grnUnitId, true, data.internalMessage, req.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return data
        } catch (err) {
            console.log(err)
            await manager.releaseTransaction();
            return new CommonResponse(false, 11188, err);

        }
    }

    async getLocationWiseStockByGrn(req: invoiceNumberRequest): Promise<CommonResponse> {
        const manager = getManager();
        const dataQry = `select g.inv_no as invNumber,i.item_name as itemName,rrp.rm_rack_code as location,stl.location_id as locationId,stl.grn_id as grnId,stl.grn_item_id as grnItemId,sum(stl.quantity) as quantity from ` + appSettings.procure_db + `.stock_log stl 
        left join `+ appSettings.procure_db + `.grn g on g.grn_id = stl.grn_id 
        left join `+ appSettings.procure_db + `.grn_items gi on gi.grn_item_id = stl.grn_item_id
        left join `+ appSettings.masters_db + `.rm_rack_position rrp on rrp.rm_rack_position_id = stl.location_id
        left join `+ appSettings.masters_db + `.items i on i.item_id = stl.item_id
         where g.inv_no = "`+ req.invoiceNumber + `" group by stl.grn_id,stl.grn_item_id,stl.item_id,stl.location_id`;
        const invoiceWiseStock = await manager.query(dataQry)
        if (invoiceWiseStock.length > 0) {
            return new CommonResponse(true, 5252, 'data retrived', invoiceWiseStock)
        } else {
            return new CommonResponse(false, 2555, 'No data')
        }
    }

    async getLocationsForStockReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager();
        let query = ` SELECT s.location_id as locationId , rp.rm_rack_code as rackPosition FROM ` + appSettings.procure_db + `.stock s LEFT JOIN ` + appSettings.masters_db + `.rm_rack_position rp ON rp.rm_rack_position_id = s.location_id WHERE s.location_id > 0 GROUP BY s.location_id `
        if (req.unitId && req.unitId != 5) {
            query = query + ' and s.unit_id = ' + req.unitId;
        }
        const data = await manager.query(query);
        if (data.length > 0) {
            return new CommonResponse(true, 11108, "Stock in transactions retrived sucessfully", data)
        } else {
            return new CommonResponse(false, 11108, "No data found")
        }
    }
    async getStockDetailsForItem(req: any): Promise<CommonResponse> {
        console.log(req);
        const manager = getManager();
        try {
            let query = "Select stock_id AS stockId,physical_quantity as availableQty,location_id AS locationId, rmrp.rm_rack_code AS location from " + appSettings.procure_db + ".stock s left join " + appSettings.masters_db + ".rm_rack_position rmrp on rmrp.rm_rack_position_id = s.location_id where s.saleorder_id = " + req.saleOrderId + " and s.item_sub_category_id = " + req.itemSubCategoryId + " and s.item_id = " + req.itemId + " and s.physical_quantity > 0 and s.unit_id = " + req.unitId + " and s.location_id > 0";
            const data = await manager.query(query);
            if (data.length > 0) {
                return new CommonResponse(true, 11108, "Stock in transactions retrived sucessfully", data)
            } else {
                return new CommonResponse(false, 11108, "No data found")
            }
        } catch (err) {
            console.log(err)
            return new CommonResponse(false, 11188, err);

        }
    }

    async getAvailableStockLocations(req: QtyRequest): Promise<CommonResponse> {
        const manager = getManager();
        try {
            let query = "Select s.item_id AS itemId,stock_id AS stockId,physical_quantity as availableQty,location_id AS locationId, rmrp.rm_rack_code AS location, 0 AS issuedQty, 0 AS requiredQty,unit_price as unitPrice from " + appSettings.procure_db + ".stock s left join " + appSettings.masters_db + ".rm_rack_position rmrp on rmrp.rm_rack_position_id = s.location_id where s.saleorder_id = 0 and s.item_category_id =" + req.itemCategoryId + " and  s.item_sub_category_id = " + req.itemSubCategoryId + " and s.item_id = " + req.itemId + " and s.unit_id = " + req.unitId ;
            if (req.saleOrderId) {
                query = query + " and saleorder_id=" + req.saleOrderId;
            } else {
                query = query + " and saleorder_id=0"
            }
            if (req.isPreparedMaterial === 'yes') {
                query = query + " and s.prepared_quantity > 0 and s.location_id = 0";
            }
            else if (req.isPreparedMaterial === 'no') {
                query = query + " and s.physical_quantity > 0 and s.location_id > 0";
            }
            const itemQty = await manager.query(query);
            // const itemQtyInfo = await this.stockRepository.createQueryBuilder("stock").select("stock_id AS stockId,physical_quantity as availableQty,location_id AS locationId, rmrp.rm_rack_code AS location, 0 AS issuedQty, 0 AS requiredQty, unit_price as unitPrice").where(`unit_id = ${req.unitId} and physical_quantity > 0 and item_category_id = ${req.itemCategoryId} and item_sub_category_id = ${req.itemSubCategoryId} and item_id = ${req.itemId}`).orderBy('size_id');
            // if (req.saleOrderId) {
            //     itemQtyInfo.andWhere(`saleorder_id=${req.saleOrderId}`);
            // } else {
            //     itemQtyInfo.andWhere('saleorder_id=0');
            // }

            // const itemQty = await itemQtyInfo.getRawOne();



            if (itemQty.length > 0) {
                return new CommonResponse(true, 1111, 'QTY Found', itemQty)
            } else {
                return new CommonResponse(false, 1111, 'QTY Not Found')
            }
        } catch (error) {
            return error
        }
    }
    async getPreviousTransactionsByGrn(req: LocationRequest): Promise<CommonResponse> {
        const manager = getManager()
        const transdataQry = `SELECT rr.rm_rack_code as location,sl.quantity FROM ` + appSettings.procure_db + `.stock_log sl 
        LEFT JOIN `+ appSettings.masters_db + `.rm_rack_position rr ON rr.rm_rack_position_id = sl.location_id
        WHERE location_id = ${req.locationId} and sl.unit_id = ${req.plantId}  AND rr.occupancy = 'Partially Occupied' ORDER BY sl.created_at DESC`;
        const locationTransData = await manager.query(transdataQry)
        if (locationTransData.length > 0) {
            return new CommonResponse(true, 9999, 'data retreived', locationTransData)
        } else {
            return new CommonResponse(false, 9999, 'No data')
        }
    }

    async updateTrimsStock(itemId, saleOrderId, consumedTrimQty, unitId, manager): Promise<boolean> {
        console.log(itemId, saleOrderId, consumedTrimQty, unitId, 'rettty')
        const soTrims = await this.stockRepository.find({ where: { saleOrderId: saleOrderId, itemId: itemId, unitId: unitId } })
        const stockQtyData = await this.stockRepository.createQueryBuilder('stock').select('sum(physical_quantity) as stockQty').where(`saleorder_id=${saleOrderId}`)
            .andWhere(`item_id=${itemId}`)
            .andWhere(`unit_id=${unitId}`).getRawOne();
        console.log(stockQtyData.stockQty, 'stockQty')
        // if()
        console.log(soTrims, 'soTrimsfff')
        if (stockQtyData.stockQty > 0 && soTrims.length > 0) {
            console.log(soTrims, 'yessssgreater')

            let remainConsumeQty = consumedTrimQty
            let updateTrimFlag = true
            for (const soTrimItem of soTrims) {
                if (soTrimItem.physicalQuantity > 0) {
                    let updatetrimStock
                    if (remainConsumeQty > 0) {
                        if (soTrimItem.physicalQuantity > remainConsumeQty) {
                            console.log(soTrimItem.physicalQuantity, 'remainConsumephyQtyiff')
                            console.log(remainConsumeQty, 'remainConsumeQtuuu')

                            updatetrimStock = await manager.getCustomRepository(StockRepository).update({ saleOrderId: saleOrderId, itemId: itemId, unitId: unitId }, { physicalQuantity: () => `physical_quantity-${consumedTrimQty}` })
                            console.log(updatetrimStock, 'updatetrimStock')
                            if (!updatetrimStock) {
                                updateTrimFlag = false
                            } else {
                                updateTrimFlag = true
                            }
                            break
                        } else {
                            console.log(soTrimItem, 'remainConsumeQtyelseee')

                            updatetrimStock = await manager.getCustomRepository(StockRepository).update({ saleOrderId: saleOrderId, itemId: itemId, unitId: unitId }, { physicalQuantity: 0 })
                            // if(remainConsumeQty > soTrimItem.physicalQuantity){
                            remainConsumeQty = remainConsumeQty - soTrimItem.physicalQuantity
                            // }
                            if (remainConsumeQty > 0) {
                                const bulkTrimsStock = await this.stockRepository.find({ where: { saleOrderId: 0, itemId: itemId, unitId: unitId } })
                                if (bulkTrimsStock.length > 0) {
                                    for (const bulktrimRec of bulkTrimsStock) {
                                        if (bulktrimRec.physicalQuantity > remainConsumeQty) {
                                            updatetrimStock = await manager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: itemId, unitId: unitId }, { physicalQuantity: () => `physical_quantity-${consumedTrimQty}` })
                                            if (!updatetrimStock) {
                                                updateTrimFlag = false
                                            } else {
                                                updateTrimFlag = true
                                            }
                                            break
                                        } else {
                                            updatetrimStock = await manager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: itemId, unitId: unitId }, { physicalQuantity: 0 })
                                            remainConsumeQty = remainConsumeQty - soTrimItem.physicalQuantity
                                            if (!updatetrimStock) {
                                                updateTrimFlag = false
                                            } else {
                                                updateTrimFlag = true
                                            }

                                        }
                                    }
                                } else {
                                    break
                                }

                            }
                        }
                        if (!updatetrimStock) {
                            updateTrimFlag = false
                            break
                        }
                    }
                }

            }
            if (updateTrimFlag) {
                return true
            } else {
                return false
            }

        } else {
            const bulkTrims = await this.stockRepository.find({ where: { saleOrderId: 0, itemId: itemId, unitId: unitId } })
            if (bulkTrims.length > 0) {
                let remainConsumeQty = consumedTrimQty
                let updateTrimFlag = true
                for (const soTrimItem of bulkTrims) {
                    let updatetrimStock
                    if (remainConsumeQty > 0) {
                        if (soTrimItem.physicalQuantity > remainConsumeQty) {
                            updatetrimStock = await manager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: itemId, unitId: unitId }, { physicalQuantity: () => `physical_quantity-${consumedTrimQty}` })
                            break
                        } else {
                            updatetrimStock = await manager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: itemId, unitId: unitId }, { physicalQuantity: 0 })
                            if (remainConsumeQty > soTrimItem.physicalQuantity) {
                                remainConsumeQty = remainConsumeQty - soTrimItem.physicalQuantity
                            }
                        }
                        if (!updatetrimStock) {
                            updateTrimFlag = false
                            break
                        }
                    }
                }
                if (updateTrimFlag) {
                    return true
                } else {
                    return false
                }

            } else {
                return false
            }
        }
    }

    async getLocationWiseStockByItem(req: ItemIDRequest): Promise<CommonResponse> {
        const manager = getManager()
        const stockQry = `SELECT rrp.rm_rack_code AS location,i.item_name AS itemName,st.item_id AS itemId,st.saleorder_id AS saleOrderId,
        st.location_id AS locationId,st.stock_id AS stockId,st.physical_quantity as quantity
         FROM ${appSettings.procure_db}.stock st
        LEFT JOIN ${appSettings.masters_db}.rm_rack_position rrp ON rrp.rm_rack_position_id = st.location_id
        LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = st.item_id
        WHERE st.item_id = ${req.itemId} and unit_id = ${req.unitId} AND st.saleorder_id = 0 and st.location_id > 0 and st.physical_quantity > 0`
        const stockData = await manager.query(stockQry)
        if (stockData.length > 0) {
            return new CommonResponse(true, 1111, 'data retrieved', stockData)
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }

    async getLocationWiseStockBySaleOrder(req: ItemIDRequest): Promise<CommonResponse> {
        const manager = getManager()
        const stockQry = `SELECT rrp.rm_rack_code AS location,i.item_name AS itemName,st.item_id AS itemId,st.saleorder_id AS saleOrderId,
        st.location_id AS locationId,st.stock_id AS stockId,st.physical_quantity as quantity
         FROM ${appSettings.procure_db}.stock st
        LEFT JOIN ${appSettings.masters_db}.rm_rack_position rrp ON rrp.rm_rack_position_id = st.location_id
        LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = st.item_id
        WHERE st.item_id = ${req.itemId} and unit_id = ${req.unitId} AND st.saleorder_id = ${req.saleOrderId} and st.location_id > 0 and st.physical_quantity > 0`
        const stockData = await manager.query(stockQry)
        if (stockData.length > 0) {
            return new CommonResponse(true, 1111, 'data retrieved', stockData)
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }

    async getLocationsForItem(req: ItemIDRequest): Promise<CommonResponse> {
        const manager = getManager();
        const locationsQuery = `select rrp.rm_rack_code AS location,st.location_id AS locationId FROM ${appSettings.procure_db}.stock st
        LEFT JOIN ${appSettings.masters_db}.rm_rack_position rrp ON rrp.rm_rack_position_id = st.location_id 
        WHERE st.item_id = ${req.itemId} and unit_id = ${req.unitId} AND st.saleorder_id = ${req.saleOrderId} and st.location_id > 0 and st.physical_quantity > 0`
        const locationsData = await manager.query(locationsQuery)
        if (locationsData.length > 0) {
            return new CommonResponse(true, 1111, 'data retrieved', locationsData)
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }

    async getSaveStockForLocationPending(req: LocationUpdateRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            let flag = true;
            let savedStockEntity;
            let isUpdate = false;
            let existingStock = await manager.getCustomRepository(StockRepository).findOne({ where: { itemId: req.itemId, saleOrderId: req.saleOrderId, unitId: req.unitId, locationId: req.locationId } });
            if (existingStock) {
                savedStockEntity = await manager.getCustomRepository(StockRepository).update({ stockId: existingStock.stockId }, { intransitQuantity: () => `intransit_quantity+${req.quantity}` });
                isUpdate = true;
            } else {
                const stockEntity = new Stock();
                stockEntity.saleOrderId = req.saleOrderId;
                stockEntity.itemId = req.itemId;
                stockEntity.unitId = req.unitId;
                stockEntity.locationId = req.locationId;
                stockEntity.itemCategoryId = req.itemCategoryId;
                stockEntity.itemSubCategoryId = req.itemSubCategoryId;
                stockEntity.sizeId = req.sizeId;
                stockEntity.physicalQuantity = 0;
                stockEntity.unitPrice = req.unitPrice;
                stockEntity.intransitQuantity = req.quantity;
                stockEntity.createdUser = req.createdUser;
                savedStockEntity = await manager.getCustomRepository(StockRepository).save(stockEntity);
                if (savedStockEntity.stockId === 0) {
                    flag = false;
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 1010, "Something went wrong. ");
                }
                else {
                    isUpdate = false;
                }
            }
            let savedStockLog
            const locationWiseStockLog = new LocationWiseTranfers();
            locationWiseStockLog.createdUser = req.createdUser;
            locationWiseStockLog.issuedQty = req.quantity;
            locationWiseStockLog.itemId = req.itemId;
            locationWiseStockLog.location = req.locationId;
            locationWiseStockLog.stockId = isUpdate ? existingStock.stockId : savedStockEntity.stockId;
            locationWiseStockLog.transferredItemId = req.packingStockTransferItemId;
            savedStockLog = await manager.getCustomRepository(LocationWiseStockLogRepository).save(locationWiseStockLog);
            if (savedStockLog.locationWiseTransferId === 0) {
                flag = false;
                await manager.releaseTransaction();
                return new CommonResponse(false, 1010, "Something went wrong. ");
            }

            let getStockId = await manager.getCustomRepository(TransferItemsRepository).findOne({ where: { packingStockTransferId: req.packingStockTransferItemId } });
            let recId: string;
            let commFlag = false;
            if (getStockId.receiveStockIds != null) {
                recId = getStockId.receiveStockIds
                commFlag = true;
            }
            console.log("____________________________")
            console.log(recId);
            console.log("******isUpdate*****");
            console.log(isUpdate);
            console.log(savedStockEntity)
            console.log(savedStockEntity.stockId)

            if (commFlag) {
                recId = recId + ',' + (isUpdate ? existingStock.stockId : savedStockEntity.stockId);
            }
            else {
                recId = (isUpdate ? existingStock.stockId : savedStockEntity.stockId);
            }
            console.log(recId);
            let updateStockIds = await manager.getCustomRepository(TransferItemsRepository).update({ packingStockTransferId: req.packingStockTransferItemId }, { receiveStockIds: recId });
            console.log("updateStockIds");
            console.log(updateStockIds);
            if (updateStockIds.affected != 1) {
                flag = false;
                await manager.releaseTransaction();
                return new CommonResponse(false, 1010, "Something went wrong with update. ");
            }
            const locationStatusUpdate = await this.rmRackCodeService.updateRmLocationStatus(new RMrackStatusRequest(req.locationId, req.locationStatus, req.unitId, req.itemSubCategoryId, req.brandId))
            console.log(locationStatusUpdate);
            if (!(locationStatusUpdate.status)) {
                flag = false;
                await manager.releaseTransaction()
                return new CommonResponse(false, 11106, 'Something went wrong in status updation');
            }
            if (req.saleOrderId > 0) {

                let bomUpdate = await this.saleService.updateAssignedAndRequiredQty(req);
                if (!bomUpdate.status) {
                    flag = false
                }
            }
            if (!flag) {
                throw new ErrorResponse(9999, "Failed To create Stock Transfer");
            } else {
                manager.completeTransaction();
                return new CommonResponse(true, 1111, 'Location updated Successfully');
            }
        }
        catch (error) {
            console.log(error);
            await manager.releaseTransaction();
            return error;
        }
    }

    async getClassificationReportData(req: ReClassificationReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = 'SELECT conversion_type AS conversionType,sid.po_number AS fromPoNumber,sd.po_number AS toPoNumber,i.item_name AS item,pcl.conversion_qty AS conversionQuantity,pcl.reason AS reason,DATE(pcl.created_at) AS convertedDate FROM `erpx_dev_procurement`.`product_conversion_log` pcl LEFT JOIN `erpx_dev_sales`.`so_invoice_details` sid ON pcl.from_sale_order_id = sid.sale_order_id LEFT JOIN `erpx_dev_sales`.`so_invoice_details` sd ON pcl.to_sale_order_id = sd.sale_order_id LEFT JOIN `erpx_dev_masters`.`items` i ON pcl.from_so_item_id = i.item_id where product_conversion_id>0'
        // if(req.fromDate && req.toDate){
        //     query=query+' And DATE(pcl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'"';
        // }
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 11108, "data retrived sucessfully", data)
        } else {
            return new CommonResponse(false, 11108, "No data found")
        }
    }

    async getSoWiseExcessInventory(req: ItemIdReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT s.item_id as itemId,uc.unit_name as unitName, s.unit_id as unitId,
        i.item_name as itemName,GROUP_CONCAT(si.po_number,'(',ROUND(b.required_qty,0),')') AS stockAllocated,
        ROUND (SUM(s.physical_quantity),0) AS stockQty , ROUND(SUM(b.required_qty),0) AS totalReqQty,
        ROUND(SUM(s.physical_quantity) - SUM(b.required_qty),0) AS excessQty 
        FROM ` + appSettings.procure_db + `.stock s 
        LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = s.item_id 
        LEFT JOIN ` + appSettings.sales_db + `.bom_details b ON b.item_id = s.item_id
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = b.sale_order_id 
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = s.unit_id
        WHERE si.sale_order_id > 0 and b.item_id = ${req.itemId} and `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 8888, 'qty retrived', data)
        } else {
            return new CommonResponse(true, 8888, 'No data found')
        }
    }

    async createinventiryLogs(dto: InvetoryLogdDto): Promise<boolean> {
        await this.inventoryLogsRepo.createQueryBuilder()
            .insert()
            .into(InvntoryLogs)
            .values([{
                oldLocationId: dto.oldLocationId, newLocationId: dto.newLocationId, oldSaleOrderId: dto.oldSaleOrderId, newSaleOrderId: dto.newSaleOrderId, stockId: dto.stockId, oldQuantity: dto.oldQuantity, updatedQuantity: dto.updatedQuantity
            }])
            .execute();
        return true;
    }
    // async getAllSubCategoryWiseStockSummaryReport(req: stockDropdownData): Promise<CommonResponse> {
    //     try {
    //         const manager = getManager();
    //         let summaryQuery = `SELECT main.item_sub_category_id as itemSubCategoryId,isc.item_sub_category AS itemSubCategoryName,main.qty AS quantity,ROUND(AVG(poi.item_cost),2) AS price,ROUND((main.qty)*(ROUND(AVG(poi.item_cost),2)),3) as amount FROM
    //         (SELECT item_sub_category_id,SUM(physical_quantity) AS qty FROM ${appSettings.procure_db}.stock s WHERE physical_quantity > 0 GROUP BY item_sub_category_id) AS main
    //         LEFT JOIN ${appSettings.procure_db}.purchase_order_items poi ON poi.item_sub_category_id = main.item_sub_category_id 
    //         LEFT JOIN 
    //               ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = main.item_sub_category_id`
            
    //         // let summaryQuery = `
    //         //   SELECT 
    //         //       agg.item_sub_category_id as itemSubCategoryId, 
    //         //       agg.item_id, 
    //         //       ROUND(agg.total_quantity, 2) AS quantity,
    //         //       ROUND(AVG(poi.item_cost), 2) AS price,
    //         //       ROUND(AVG(poi.item_cost) * agg.total_quantity, 2) AS amount,
    //         //       isc.item_sub_category AS itemSubCategoryName
    //         //   FROM 
    //         //       (SELECT
    //         //           s.item_sub_category_id,
    //         //           s.item_id,
    //         //           SUM(s.physical_quantity) AS total_quantity
    //         //       FROM
    //         //           ${appSettings.procure_db}.stock s
    //         //       GROUP BY
    //         //           s.item_sub_category_id,
    //         //           s.item_id) agg
    //         //   LEFT JOIN 
    //         //       ${appSettings.procure_db}.purchase_order_items poi ON poi.item_name = agg.item_id
    //         //   LEFT JOIN 
    //         //       ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = agg.item_sub_category_id
    //         //   WHERE 1=1`;
    
    //         if (req.itemSubCategoryId) {
    //             console.log(req, '------------------------');
    //             summaryQuery += ` AND main.item_sub_category_id = ${req.itemSubCategoryId}`;
    //         }
    
    //         summaryQuery += " GROUP BY main.item_sub_category_id";
    
    //         const result = await manager.query(summaryQuery);
    //         if (result.length > 0) {
    //             return new CommonResponse(true, 1, 'Data retrieved successfully', result);
    //         } else {
    //             return new CommonResponse(false, 0, 'No data found', []);
    //         }
    //     } catch (err) {
    //         throw err;
    //     }
    // }
    
//     async getAllDeadStockReport(req?: stockDropdownData): Promise<CommonResponse> {
//         try {
//             const manager = getManager();
//             let deadQuery = ` SELECT 
//   s.created_at AS date, 
//   s.item_category_id AS itemCategoryId,
//   s.item_sub_category_id AS itemSubCategoryId,
//   s.stock_id,
//   i.item_name AS itemName,
//   isc.item_sub_category AS itemSubCategoryName,
//   ic.item_category AS itemCategory,
//   SUM(s.physical_quantity) AS quantity,
//   i.item_id,
//   DATEDIFF(CURDATE(), s.created_at) AS aging
// FROM 
//   ${appSettings.procure_db}.stock s
// LEFT JOIN 
//     ${appSettings.masters_db}.items i ON i.item_category_id = s.item_category_id
// LEFT JOIN 
//   ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = s.item_sub_category_id
// LEFT JOIN 
//   ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = s.item_category_id
// WHERE 
//   s.created_at < DATE_SUB(CURDATE(), INTERVAL 90 DAY) 

// `;

//             if (req.itemSubCategoryId) {
//                 deadQuery += ` AND s.item_sub_category_id = ${req.itemSubCategoryId}`;
//             }
//             if (req.itemCategoryId) {
//                 deadQuery += ` AND s.item_category_id = ${req.itemCategoryId}`;
//             }
//             if (req.itemId) {
//                 deadQuery += ` AND i.item_id = ${req.itemId}`;
//             }

//             deadQuery += " GROUP BY i.item_id, s.stock_id ";

//             const result22 = await manager.query(deadQuery);

//             if (result22.length > 0) {
//                 return new CommonResponse(true, 1, 'Data retrieved successfully', result22);
//             } else {
//                 return new CommonResponse(false, 0, 'No data found', []);
//             }
//         } catch (err) {
//             throw (err);
//         }
//     }

async getAllSubCategoryWiseStockSummaryReport(req: stockDropdownData): Promise<CommonResponse> {
    console.log(req, "uu");
    try {
        const manager = getManager();
        
        // Start building the query
        let summaryQuery = `SELECT 
                                main.item_sub_category_id as itemSubCategoryId,
                                isc.item_sub_category AS itemSubCategoryName,
                                main.qty AS quantity,
                                ROUND(COALESCE(AVG(poi.item_cost), 0), 2) AS price,
                                ROUND((COALESCE(main.qty, 0)) * (ROUND(COALESCE(AVG(poi.item_cost), 0), 2)), 3) AS amount
                            FROM
                                (SELECT 
                                    item_sub_category_id, 
                                    SUM(physical_quantity) AS qty 
                                FROM 
                                    ${appSettings.procure_db}.stock s 
                                WHERE 
                                    physical_quantity > 0 `;
        
        // Add conditions for `unitId` and `itemSubCategoryId` if they are provided
        if (req.unitId) {
            summaryQuery += ` AND unit_id = ${req.unitId}`;
        }
        if (req.itemSubCategoryId) {
            summaryQuery += ` AND item_sub_category_id = ${req.itemSubCategoryId}`;
        }
        
        summaryQuery += ` GROUP BY item_sub_category_id) AS main
                          LEFT JOIN ${appSettings.procure_db}.purchase_order_items poi 
                                ON poi.item_sub_category_id = main.item_sub_category_id 
                          LEFT JOIN ${appSettings.masters_db}.item_sub_categories isc 
                                ON isc.item_sub_category_id = main.item_sub_category_id`;
        
        // Final GROUP BY clause
        summaryQuery += " GROUP BY main.item_sub_category_id";
        
        // Execute the query
        const result = await manager.query(summaryQuery);
        
        if (result.length > 0) {
            return new CommonResponse(true, 1, 'Data retrieved successfully', result);
        } else {
            return new CommonResponse(false, 0, 'No data found', []);
        }
    } catch (err) {
        throw err;
    }
}

      
async getAllDeadStockReport(req?: stockDropdownData): Promise<CommonResponse> {

    console.log(req,"uuu")
    try {
        let deadQuery;
        const manager = getManager();

        if (req?.dateRange === DateEnum.All) {
            
            deadQuery = `
            SELECT 
                DATE_FORMAT(s.created_at, '%d-%m-%Y') AS date,
                s.item_category_id AS itemCategoryId,
                s.item_sub_category_id AS itemSubCategoryId,
                s.stock_id,
                i.item_name AS itemName,
                isc.item_sub_category AS itemSubCategoryName,
                ic.item_category AS itemCategory,
                SUM(s.physical_quantity) AS quantity,
                i.item_id,
                DATEDIFF(CURDATE(), s.created_at) AS aging
            FROM 
                ${appSettings.procure_db}.stock s
            LEFT JOIN 
                ${appSettings.masters_db}.items i ON i.item_id = s.item_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = s.item_sub_category_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = s.item_category_id
            WHERE 
                s.created_at BETWEEN CURRENT_DATE - INTERVAL 90 DAY AND CURRENT_DATE
            `;
        } else if (req?.dateRange === DateEnum.ThreeToSixMonths) {
            console.log("3-6")

            deadQuery = `
            SELECT 
                DATE_FORMAT(s.created_at, '%d-%m-%Y') AS date,
                s.item_category_id AS itemCategoryId,
                s.item_sub_category_id AS itemSubCategoryId,
                s.stock_id,
                i.item_name AS itemName,
                isc.item_sub_category AS itemSubCategoryName,
                ic.item_category AS itemCategory,
                SUM(s.physical_quantity) AS quantity,
                i.item_id,
                DATEDIFF(CURDATE(), s.created_at) AS aging
            FROM 
                ${appSettings.procure_db}.stock s
            LEFT JOIN 
                ${appSettings.masters_db}.items i ON i.item_id = s.item_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = s.item_sub_category_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = s.item_category_id
            WHERE 
                 s.created_at BETWEEN DATE_SUB(CURDATE(), INTERVAL 180 DAY) 
                      AND DATE_SUB(CURDATE(), INTERVAL 90 DAY)
        
            `;
        } else if (req?.dateRange === DateEnum.SixToTwelveMonths) {
            console.log("6-12")

            deadQuery = `
            SELECT 
                DATE_FORMAT(s.created_at,'%d-%m-%Y') AS date, 
                s.item_category_id AS itemCategoryId,
                s.item_sub_category_id AS itemSubCategoryId,
                s.stock_id,
                i.item_name AS itemName,
                isc.item_sub_category AS itemSubCategoryName,
                ic.item_category AS itemCategory,
                SUM(s.physical_quantity) AS quantity,
                i.item_id,
                DATEDIFF(CURDATE(), s.created_at) AS aging
            FROM 
                ${appSettings.procure_db}.stock s
            LEFT JOIN 
                ${appSettings.masters_db}.items i ON i.item_id = s.item_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = s.item_sub_category_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = s.item_category_id
            WHERE 
                s.created_at BETWEEN DATE_SUB(CURDATE(), INTERVAL 365 DAY) 
                      AND DATE_SUB(CURDATE(), INTERVAL 180 DAY)
          
            `;
        } else if (req?.dateRange === DateEnum.OneYearAbove) {

            console.log("oneyear")
            deadQuery = `
            SELECT 
                DATE_FORMAT(s.created_at, '%d-%m-%Y') AS date,
                s.item_category_id AS itemCategoryId,
                s.item_sub_category_id AS itemSubCategoryId,
                s.stock_id,
                i.item_name AS itemName,
                isc.item_sub_category AS itemSubCategoryName,
                ic.item_category AS itemCategory,
                SUM(s.physical_quantity) AS quantity,
                i.item_id,
                DATEDIFF(CURDATE(), s.created_at) AS aging
            FROM 
                ${appSettings.procure_db}.stock s
            LEFT JOIN 
                ${appSettings.masters_db}.items i ON i.item_id = s.item_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = s.item_sub_category_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = s.item_category_id
            WHERE 
                 s.created_at < DATE_SUB(CURDATE(), INTERVAL 365 DAY)
          
            `;
        } else {
            deadQuery = `
            SELECT 
                DATE_FORMAT(s.created_at, '%d-%m-%Y') AS date,
                s.item_category_id AS itemCategoryId,
                s.item_sub_category_id AS itemSubCategoryId,
                s.stock_id,
                i.item_name AS itemName,
                isc.item_sub_category AS itemSubCategoryName,
                ic.item_category AS itemCategory,
                SUM(s.physical_quantity) AS quantity,
                i.item_id,
                DATEDIFF(CURDATE(), s.created_at) AS aging
            FROM 
                ${appSettings.procure_db}.stock s
            LEFT JOIN 
                ${appSettings.masters_db}.items i ON i.item_id = s.item_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = s.item_sub_category_id
            LEFT JOIN 
                ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = s.item_category_id
            WHERE 
                s.created_at BETWEEN CURRENT_DATE - INTERVAL 90 DAY AND CURRENT_DATE
            `
        }

        // Apply additional filters if provided
        if (req?.itemSubCategoryId) {
            deadQuery += ` AND s.item_sub_category_id = ${req.itemSubCategoryId}`;
        }
        if (req?.itemCategoryId) {
            deadQuery += ` AND s.item_category_id = ${req.itemCategoryId}`;
        }
        if (req?.itemId) {
            deadQuery += ` AND i.item_id = ${req.itemId}`;
        }

        deadQuery += " GROUP BY i.item_name  HAVING SUM(s.physical_quantity) > 0"

        const result22 = await manager.query(deadQuery);

        if (result22.length > 0) {
            return new CommonResponse(true, 1, 'Data retrieved successfully', result22);
        } else {
            return new CommonResponse(false, 0, 'No data found', []);
        }
    } catch (err) {
        throw err;
    }
}




    // async getStoreConsumptionSummary(req?: stockDropdownData): Promise<CommonResponse> {
    //     try {
    //         const manager = getManager();
    //         let storeQuery = `
    //             SELECT sc.item_id, i.item_sub_category_id, AVG(poi.item_cost) AS averagePrice,
    //                    AVG(poi.item_cost) * SUM(s.physical_quantity) AS amount, isc.item_sub_category as itemSubCategoryName,
    //                    SUM(s.physical_quantity) AS quantity
    //             FROM ${appSettings.procure_db}.store_consumption sc
    //             LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = sc.item_id
    //             LEFT JOIN ${appSettings.procure_db}.purchase_order_items poi ON poi.item_name = sc.item_id 
    //             LEFT JOIN ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = i.item_sub_category_id
    //             LEFT JOIN ${appSettings.procure_db}.stock s ON s.item_id = sc.item_id
    //         `;

    //         if (req.itemSubCategoryId) {
    //             storeQuery += ' WHERE i.item_sub_category_id = ' + req.itemSubCategoryId;
    //         }
    //         storeQuery += ' GROUP BY i.item_sub_category_id';
    //         const result33 = await manager.query(storeQuery);
    //         if (result33.length > 0) {
    //             return new CommonResponse(true, 1, 'Data retrieved successfully', result33);
    //         } else {
    //             return new CommonResponse(false, 0, 'No data found', []);
    //         }
    //     } catch (err) {
    //         throw err;
    //     }
    // }

    async getStoreConsumptionSummary(req?: stockDropdownData): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let storeQuery = `SELECT main.item_sub_category_id AS itemSubCategoryId,isc.item_sub_category AS itemSubCategoryName,main.qty AS quantity,DATE_FORMAT(main.consumed_date, '%Y-%m-%d') AS consumedDate,
            ROUND(IFNULL(AVG(poi.item_cost), 0), 2) AS averagePrice,ROUND(main.qty * ROUND(IFNULL(AVG(poi.item_cost), 0), 2), 3) AS amount FROM
            (SELECT DATE(s.consumed_date) AS consumed_date,SUM(issued_quantity) AS qty,i.item_sub_category_id FROM erpx_dev_procurement.store_consumption s
            LEFT JOIN erpx_dev_masters.items i ON i.item_id = s.item_id
              GROUP BY i.item_sub_category_id) AS main
            LEFT JOIN erpx_dev_procurement.purchase_order_items poi ON poi.item_sub_category_id = main.item_sub_category_id 
            LEFT JOIN 
                  erpx_dev_masters.item_sub_categories isc ON isc.item_sub_category_id = main.item_sub_category_id`

            if (req.itemSubCategoryId) {
                storeQuery += ' WHERE main.item_sub_category_id = ' + req.itemSubCategoryId;
            }
            if (req.fromDate && req.toDate) {
                storeQuery += ` WHERE DATE_FORMAT(main.consumed_date, '%Y-%m-%d') BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
            }
            
            storeQuery += ' GROUP BY main.item_sub_category_id';
            const result33 = await manager.query(storeQuery);
            if (result33.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', result33);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }

    async getItemNames(): Promise<CommonResponse> {
        try {
            const manager = getManager();
        //     let itemQuery = `select  i.item_id as itemId, i.item_name as itemName ,s.item_category_id AS itemCategoryId,s.created_at AS date
        //  FROM ${appSettings.procure_db}.stock s
        //   LEFT JOIN ${appSettings.masters_db}.items i ON i.item_category_id = s.item_category_id
        //  WHERE s.created_at < DATE_SUB(CURDATE(), INTERVAL 90 DAY)
        //  group by s.item_category_id`;
        let itemQuery = `select distinct i.item_id as itemId, i.item_name as itemName,s.item_id
        FROM ${appSettings.procure_db}.stock s
         LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = s.item_id`;


            const result77 = await manager.query(itemQuery);
            if (result77.length > 0) {
                return new CommonResponse(true, 1121, 'Data retrieved successfully', result77)
            } else {
                return new CommonResponse(false, 1121, 'No data')
            }
        } catch (err) {
            throw err;
        }
    }
    async getItemCategory(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let catQuery = ` SELECT s.item_category_id AS itemCategoryId,ic.item_category AS categoryName 
        FROM ${appSettings.procure_db}.stock s
         LEFT JOIN ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = s.item_category_id
        WHERE s.created_at < DATE_SUB(CURDATE(), INTERVAL 90 DAY)
                group by s.item_category_id`;
            const result88 = await manager.query(catQuery);
            if (result88.length > 0) {
                return new CommonResponse(true, 1121, 'Data retrieved successfully', result88)
            } else {
                return new CommonResponse(false, 1121, 'No data')
            }
        } catch (err) {
            throw err;
        }

    }



    async getItemSubCategory(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let subCatQuery = ` SELECT s.item_sub_category_id AS itemSubCategoryId , iis.item_sub_category AS itemSubCategoryName , s.unit_id 
        FROM ${appSettings.procure_db}.stock s
        LEFT JOIN ${appSettings.masters_db}.item_sub_categories iis ON iis.item_sub_category_id = s.item_sub_category_id
         WHERE s.created_at < DATE_SUB(CURDATE(), INTERVAL 90 DAY)
        group by s.item_sub_category_id`;
            const result99 = await manager.query(subCatQuery);
            if (result99.length > 0) {
                return new CommonResponse(true, 1121, 'Data retrieved successfully', result99)
            } else {
                return new CommonResponse(false, 1121, 'No data')
            }
        } catch (err) {
            throw err;
        }

    }
    async getAllReclassificationView():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT 
    pcl.conversion_type AS conversionType,
    pcl.reason,
    pcl.conversion_qty AS conversionQuantity,
    pcl.location_id,
    pcl.unit_id,
    pcl.from_sale_order_id,
    pcl.to_sale_order_id,
    pcl.from_so_item_id,
    pcl.to_so_item_id,
    so_from.sale_order_no AS fromSaleOrderNumber,
    so_to.sale_order_no AS toSaleOrderNumber,
    i_from.item_name AS fromItemName,
    i_to.item_name AS toItemName
FROM ${appSettings.procure_db}.product_conversion_log pcl
LEFT JOIN ${appSettings.sales_db}.sale_order so_from 
    ON so_from.sale_order_id = pcl.from_sale_order_id
LEFT JOIN  ${appSettings.sales_db}.sale_order so_to 
    ON so_to.sale_order_id = pcl.to_sale_order_id
LEFT JOIN ${appSettings.masters_db}.items i_from 
    ON i_from.item_id = pcl.from_so_item_id
LEFT JOIN ${appSettings.masters_db}.items i_to 
    ON i_to.item_id = pcl.to_so_item_id`;
    const result = await manager.query(query)
        if (result.length > 0) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', result)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    } catch(err)
    {
        throw err
    }
}



}




